<template>
  <div>
    <div class="top-nav">
      <div class="nav-left-section">
        <div class="logo-area" @click="goHome">
          <div class="logo-icon">
            <img src="@/assets/icon/logo.png" alt="" srcset="">
          </div>
          <span class="logo-sub">企业中心</span>
        </div>
        <div v-if="hasCompanyArea" class="company-area">
          <el-dropdown trigger="click" @command="handleCompanyCommand" @visible-change="onCompanyDropdownVisible">
            <div class="company-name-wrapper" :class="{ active: companyDropdownVisible }">
              <span class="company-name">{{ companyName }}</span>
              <i class="el-icon-arrow-down company-arrow" :class="{ 'is-reverse': companyDropdownVisible }"></i>
            </div>
            <!-- <span class="role-text">{{ userInfo.company.default_contract_main_name || "--" }}</span> -->
            <el-dropdown-menu slot="dropdown" class="company-dropdown-menu">
              <el-dropdown-item v-for="company in companyList" :key="company.company_id" :command="company"
                :class="{ 'is-current': company.company_id === default_company_id }">
                <span class="company-item-name">{{ company.company_name }}</span>
                <i v-if="company.company_name === companyName" class="el-icon-check company-check-icon"
                  style="margin-left:13px;"></i>
              </el-dropdown-item>
              <el-dropdown-item command="addCompany">
                <span style="display:flex;align-items:center;justify-content:center;width:100%;color:#F08328;">
                  <span
                    style="display:inline-flex;align-items:center;justify-content:center;width:15px;height:15px;margin-right:8px;border-radius:50%;background:#FFF3EC;color:#F08328;font-size:14px;font-weight:700;line-height:1px;">+</span>
                  <span style="color:#F08328;font-size:14px;font-weight:500;">新增企业</span>
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-button
          v-if="profileLoaded && !hasCertifiedCompany()"
          type="warning"
          plain
          size="mini"
          icon="el-icon-warning-outline"
          :loading="certificationLoading"
          @click="openCertDialog"
        >未认证</el-button>
      </div>
      <div class="nav-center">
        <div v-for="item in navItems" :key="item.name" class="nav-item primary-menu"
          :class="{ active: activeNav === item.name }" @click="handleNavClick(item)">
          <span :id="item.name === '配置中心' ? 'config-center-guide-target' : null"
            :class="{ 'config-guide-nav-label': item.name === '配置中心' }">{{ item.name }}</span>
          <el-badge v-if="item.badge" :value="item.badge" class="nav-badge" :max="99" />
        </div>
      </div>
      <div class="nav-right-section">
        <!-- 客服动画图标 -->
        <div class="customer-service-btn" :class="{ active: customerServiceVisible }" @click="contactService">
          <span class="cs-pulse-ring"></span>
          <span class="cs-pulse-ring delay"></span>
          <div class="cs-icon-wrapper">
            <i class="el-icon-headset"></i>
          </div>
          <span class="cs-badge">在线</span>
        </div>
        <!-- 用户头像+名称下拉区域 -->
        <el-dropdown ref="userDropdown" trigger="click" @command="handleUserCommand"
          @visible-change="onDropdownVisible">
          <div class="user-area" :class="{ active: dropdownVisible }">
            <div class="user-avatar-wrap">
              <span v-if="isSuperVip" class="super-vip-label">
                <span class="super-vip-text">VIP</span>
              </span>
              <el-avatar :size="44" class="user-avatar">
                <img :src="userInfo.member.avatar || require('@/assets/icon/dfImg.png')" alt="" srcset="">
              </el-avatar>
            </div>
            <div class="user-name-wrap">
              <div class="user-name-row">
                <span class="user-name">{{ userInfo.user.user_name || "" }}</span>
                <span v-if="Number(isCertified) === 1" class="user-legal-label">法人</span>
              </div>
              <span v-if="userInfo.role_name" class="user-role-label">{{ userInfo.role_name }}</span>
            </div>
            <i class="el-icon-arrow-down user-arrow" :class="{ 'is-reverse': dropdownVisible }"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
            <div class="dropdown-divider"></div>
            <!-- <el-dropdown-item command="profile">
              <i class="el-icon-user"></i> 个人中心
            </el-dropdown-item>
            <el-dropdown-item command="settings">
              <i class="el-icon-setting"></i> 账号设置
            </el-dropdown-item> -->
            <div v-if="isSuperVip" class="super-vip-dropdown-card" role="button" tabindex="0"
              @click.stop="openSuperVipBenefits" @keyup.enter.stop="openSuperVipBenefits">
              <div class="super-vip-card-title">权益卡已开通</div>
              <div v-if="superVipExpireDate" class="super-vip-card-expire">有效期至{{ superVipExpireDate }}</div>
            </div>
            <el-dropdown-item command="certification">
              <i class="el-icon-s-check"></i> 企业认证
            </el-dropdown-item>
            <el-dropdown-item command="wallet">
              <i class="el-icon-wallet"></i> 企业钱包
            </el-dropdown-item>
            <el-dropdown-item command="switchEntity">
              <i class="el-icon-sort"></i> 主体切换
            </el-dropdown-item>
            <el-dropdown-item v-if="profileLoaded && hasCertifiedCompany()" command="industryPosition">
              <i class="el-icon-menu"></i> 行业岗位设置
            </el-dropdown-item>
            <el-dropdown-item v-if="profileLoaded && hasCertifiedCompany()" command="invoiceSettings" :disabled="invoiceSettingsLoading">
              <i :class="invoiceSettingsLoading ? 'el-icon-loading' : 'el-icon-document'"></i> 开票信息设置
            </el-dropdown-item>
            <el-dropdown-item command="password">
              <i class="el-icon-lock"></i> 修改密码
            </el-dropdown-item>
            <!-- <el-dropdown-item command="certified" v-if="!isCertified">
              <i class="el-icon-s-check"></i> 实名认证
            </el-dropdown-item> -->
            <el-dropdown-item command="theme" divided>
              <i class="el-icon-magic-stick"></i>
              <span>一键换肤</span>
            </el-dropdown-item>
            <el-dropdown-item command="logout" divided class="logout-item">
              <i class="el-icon-switch-button"></i> 退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 二级菜单 -->
    <div v-if="showSubMenu && subMenuItems.length > 0" class="top-nav-children">
      <div class="nav-center">
        <div v-for="subItem in subMenuItems" :key="subItem.path" class="nav-item sub-menu"
          :class="{ active: $route.path === subItem.path.split('?')[0] }" @click="handleSubNavClick(subItem)">
          <span :id="subItem.name === 'Basic' ? 'config-guide-organization-tab' : subItem.name === 'ServiceProviderEntity' ? 'config-guide-service-tab' : null"
            :class="{ 'config-guide-service-label': subItem.name === 'ServiceProviderEntity' }">{{ subItem.title }}</span>
        </div>
      </div>
    </div>

    <!-- 固定问答在线客服 -->
    <transition name="customer-service-pop">
      <section v-if="customerServiceVisible" ref="customerServicePanel" class="customer-service-panel"
        :class="{ 'is-dragging': customerServiceDragging }" :style="customerServicePanelStyle" role="dialog"
        aria-modal="false" aria-label="在线客服" @click.stop>
        <header class="customer-service-header" @mousedown="startCustomerServiceDrag">
          <div class="customer-service-profile">
            <div class="customer-service-avatar">
              <i class="el-icon-headset"></i>
              <span class="customer-service-status-dot"></span>
            </div>
            <div class="customer-service-heading">
              <strong>在线客服</strong>
              <span>企业服务助手 · 在线为您解答</span>
            </div>
          </div>
          <div class="customer-service-actions">
            <button type="button" class="customer-service-action" title="重新开始" aria-label="重新开始"
              @click="resetCustomerService">
              <i class="el-icon-refresh-right"></i>
            </button>
            <button type="button" class="customer-service-action" title="关闭客服" aria-label="关闭客服"
              @click="closeCustomerService">
              <i class="el-icon-close"></i>
            </button>
          </div>
        </header>

        <div ref="customerServiceMessages" class="customer-service-messages" aria-live="polite">
          <div class="customer-service-time">企业服务助手</div>
          <div v-for="(message, index) in customerServiceMessages" :key="index" class="customer-service-message"
            :class="message.type">
            <div class="customer-service-message-avatar">
              <i :class="message.type === 'service' ? 'el-icon-headset' : 'el-icon-user-solid'"></i>
            </div>
            <div class="customer-service-bubble">{{ message.content }}</div>
          </div>
          <div v-if="customerServiceReplying" class="customer-service-message service">
            <div class="customer-service-message-avatar">
              <i class="el-icon-headset"></i>
            </div>
            <div class="customer-service-bubble customer-service-typing" aria-label="客服正在回复">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>

        <div class="customer-service-faq">
          <div class="customer-service-faq-title">
            <div>
              <i class="el-icon-chat-dot-round"></i>
              <strong>猜你想问</strong>
            </div>
            <span>点击问题快速咨询</span>
          </div>
          <div class="customer-service-question-list">
            <button v-for="(item, index) in customerServiceQuestions" :key="item.id" type="button"
              class="customer-service-question" :disabled="customerServiceReplying"
              @click="selectCustomerQuestion(item)">
              <span class="customer-service-question-index">{{ index + 1 }}</span>
              <span class="customer-service-question-text">{{ item.question }}</span>
              <i class="el-icon-arrow-right"></i>
            </button>
          </div>
          <div class="customer-service-footer-tip">
            <i class="el-icon-circle-check"></i>
            以上为常见问题自助解答
          </div>
        </div>
      </section>
    </transition>

    <!-- 企业认证弹框 -->
    <el-dialog :visible.sync="showUnverifiedDialog" width="630px" :show-close="false" :close-on-click-modal="false"
      custom-class="unverified-guide-dialog" append-to-body>
      <button class="unverified-skip" type="button" @click="skipUnverifiedGuide">跳过</button>
      <div class="unverified-guide">
        <div class="unverified-content">
          <h3>完成企业认证</h3>
          <p>认证后即可畅享 AI 招聘专家、智能制单、用工管理、风控分析、企业支付、发票服务等核心功能，让企业招聘与用工管理更高效、更安全</p>
          <el-button type="primary" class="unverified-action" @click="startUnverifiedCertification">立即认证</el-button>
          <div class="unverified-tip">您也可以稍后在【个人中心 - 企业认证】中完成认证</div>
        </div>
        <img class="unverified-icon" src="@/assets/img/unverifiedIcon.png" alt="企业认证">
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showCertDialog" width="1200px" :close-on-click-modal="false" custom-class="cert-dialog"
      top="6vh" :show-close="true" v-dialogDrag>
      <div slot="title" class="cert-dialog-title">
        <span class="cert-title-text">企业认证</span>
      </div>
      <div class="cert-dialog-body">
        <!-- 左侧插画 -->
        <div class="cert-left">
          <div class="cert-illustration">
            <img class="cert-img" src="@/assets/img/corporateCertification.png" alt="企业认证">
          </div>
        </div>
        <!-- 右侧表单 -->
        <div class="cert-right">
          <div v-if="isCompanyCertified" class="cert-status-row">
            <div class="cert-success-status">
              <i class="el-icon-success"></i>
              <span>已完成企业认证</span>
            </div>
            <div class="cert-success-status legal-cert-status" :class="{ 'is-uncertified': !isCertified }">
              <i :class="isCertified ? 'el-icon-success' : 'el-icon-warning'"></i>
              <span>{{ isCertified ? '已完成法人认证' : '未完成法人认证' }}</span>
            </div>
          </div>
          <div class="cert-section-title">注册信息</div>

          <el-form :model="certForm" :rules="certRules" ref="certForm" label-width="106px" label-position="right"
            size="small" class="cert-register-form">
            <el-form-item v-if="!isCompanyCertified" label="营业执照" prop="licenseFile" required>
              <div class="cert-upload-row">
                <div class="cert-upload-area">
                  <el-upload class="cert-upload" :class="{ 'has-file': certForm.licenseFileList.length > 0 }"
                    v-loading="licenseUploading" action="#" :auto-upload="false" :on-change="handleLicenseChange"
                    :on-remove="handleLicenseRemove" :on-preview="handleLicensePreview"
                    :file-list="certForm.licenseFileList" list-type="picture-card" :limit="1" accept=".jpg,.jpeg,.png">
                    <div class="upload-trigger">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                </div>
                <div class="cert-upload-tips">
                  <p>1. 营业执照名称需与企业名称一致</p>
                  <p>2. 证件细节需清晰可辨，内容真实有效</p>
                  <p>3. 图片格式为 JPEG、JPG 或 PNG，大小不超过 2MB</p>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-else label="营业执照">
              <el-image v-if="certForm.orgImage" class="cert-license-view" :src="certForm.orgImage"
                :preview-src-list="[certForm.orgImage]" fit="cover"></el-image>
              <span v-else class="cert-readonly-text">--</span>
            </el-form-item>

            <el-form-item label="公司名称" prop="companyName">
              <span class="cert-readonly-text">{{ certForm.companyName || '请先上传营业执照' }}</span>
            </el-form-item>

            <el-form-item label="统一信用代码" prop="creditCode">
              <span class="cert-readonly-text">{{ certForm.creditCode || '请先上传营业执照' }}</span>
            </el-form-item>

            <el-form-item v-if="!isCompanyCertified" label="省市区" prop="region" required>
              <el-cascader v-model="certForm.region" :options="regionOptions"
                :props="{ value: 'value', label: 'label', children: 'children' }" placeholder="请选择省市区" clearable
                style="width: 100%"></el-cascader>
            </el-form-item>

            <el-form-item label="详细地址" prop="detailAddress" required>
              <span v-if="isCompanyCertified" class="cert-readonly-text">{{ certForm.detailAddress || '--' }}</span>
              <el-input v-else class="cert-detail-address" v-model="certForm.detailAddress" type="textarea" :rows="3"
                placeholder="请输入公司地址"></el-input>
            </el-form-item>

            <el-form-item label="开户银行">
              <span v-if="isCompanyCertified" class="cert-readonly-text">{{ certForm.bankOpenAccount || '--' }}</span>
              <el-input v-else v-model="certForm.bankOpenAccount" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="汇款账户">
              <span v-if="isCompanyCertified" class="cert-readonly-text">{{ certForm.bankNo || '--' }}</span>
              <el-input v-else v-model="certForm.bankNo" placeholder="请输入"></el-input>
            </el-form-item>

            <template v-if="isCompanyCertified && legalCertMode">
              <el-form-item label="法人姓名" prop="card_name" required>
                <el-input v-model.trim="certForm.card_name" placeholder="请输入法人姓名" maxlength="50"></el-input>
              </el-form-item>
              <el-form-item label="法人身份证" prop="card_no" required>
                <el-input v-model.trim="certForm.card_no" placeholder="请输入法人身份证号" maxlength="18"></el-input>
              </el-form-item>
            </template>

            <el-form-item v-if="!isCompanyCertified" label="认证方式" required>
              <el-radio-group v-model="certForm.authMethod" class="cert-auth-method">
                <el-radio label="legal">法人</el-radio>
                <el-radio label="admin">管理员</el-radio>
              </el-radio-group>
            </el-form-item>

            <div style="margin-left: 110px; margin-top: 4px; margin-bottom: 14px;" v-if="!isCompanyCertified">
              <div v-if="certForm.authMethod === 'legal'">
                法人认证的企业账号：拥有平台最高权限，且支持自有员工薪资结算。
              </div>
              <div v-if="certForm.authMethod === 'admin'">
                管理员认证的企业账号：具备企业管理权限，仅不支持自有员工薪资结算。
              </div>
            </div>

            <template v-if="!isCompanyCertified && certForm.authMethod === 'legal'">
              <el-form-item label="法人姓名" prop="card_name" required>
                <el-input v-model.trim="certForm.card_name" placeholder="请输入法人姓名" maxlength="50"></el-input>
              </el-form-item>
              <el-form-item label="法人身份证" prop="card_no" required>
                <el-input v-model.trim="certForm.card_no" placeholder="请输入法人身份证号" maxlength="18"></el-input>
              </el-form-item>
            </template>

            <!-- <template v-if="!isCompanyCertified && certForm.authMethod === 'admin'">
              <el-form-item label="管理员姓名" required>
                <el-input v-model="certForm.adminName" placeholder="请输入管理员姓名"></el-input>
              </el-form-item>
              <el-form-item label="管理员身份证" required>
                <el-input v-model="certForm.adminIdCard" placeholder="请输入管理员身份证号"></el-input>
              </el-form-item>
            </template> -->

            <el-form-item v-if="!isCompanyCertified" label-width="0" class="cert-sync-row">
              <!-- <el-checkbox v-model="certForm.syncYjtHistoryData"> -->
              *同意将易匠通历史业务数据同步迁移至百工人服一站式综合用工平台。
              <!-- </el-checkbox> -->
            </el-form-item>

            <el-form-item v-if="isCompanyCertified" label-width="0" class="cert-next-row">
              <template v-if="legalCertMode">
                <el-button class="cert-cancel-button" @click="cancelLegalCertification">取消</el-button>
                <el-button type="warning" :loading="certSubmitting" @click="submitLegalCertification">提交</el-button>
              </template>
              <template v-else>
                <!-- <el-button v-if="needsLegalCertification" type="warning" @click="startLegalCertification">认证法人</el-button> -->
                <el-button type="warning" @click="startCertOtherCompany">认证其他企业</el-button>
              </template>
            </el-form-item>

            <el-form-item v-else label-width="0" class="cert-next-row">
              <el-button type="warning" :loading="certSubmitting" @click="submitCert">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <el-image-viewer v-if="licensePreviewVisible" :url-list="[licensePreviewUrl]" :z-index="10000"
      :append-to-body="true" :on-close="closeLicensePreview" />

    <!-- 修改密码弹框 -->
    <el-dialog :visible.sync="showPwdDialog" width="460px" :close-on-click-modal="false" custom-class="pwd-dialog"
      @close="resetPwdForm">
      <div slot="title" class="pwd-dialog-title">
        <i class="el-icon-lock"></i>
        <span>修改密码</span>
      </div>
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="100px" label-position="left" size="small">
        <el-form-item label="当前密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" placeholder="请输入当前密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
        <div class="pwd-form-tip">* 首次修改密码为手机号后6位，仅用于修改密码不可登录。</div>
      </el-form>
      <span slot="footer" class="pwd-dialog-footer">
        <el-button @click="showPwdDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitPwd">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 实名认证弹框 -->
    <el-dialog :visible.sync="showCertifiedDialog" width="460px" :close-on-click-modal="false" custom-class="pwd-dialog"
      @close="resetCardForm">
      <div slot="title" class="pwd-dialog-title">
        <i class="el-icon-user"></i>
        <span>实名认证</span>
      </div>
      <el-form :model="cardForm" :rules="cardRules" ref="cardForm" label-width="100px" label-position="left"
        size="small">
        <el-form-item label="身份证姓名" prop="card_name">
          <el-input v-model="cardForm.card_name" placeholder="请输入身份证姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="card_no">
          <el-input v-model="cardForm.card_no" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="pwd-dialog-footer">
        <el-button @click="showCertifiedDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitCard">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 法人认证二维码弹框-->
    <LegalAuthQrDialog :visible.sync="showQrDialog" :company-name="certForm.companyName" @face-check-success="handleQrFaceCheckSuccess" />

    <!-- 实名认证二维码弹框 -->
    <RealNameAuthQrDialog :visible.sync="showRealNameQrDialog" @face-check-success="handleRealNameQrFaceCheckSuccess" />

    <!-- 换肤抽屉遮罩 -->
    <div class="theme-drawer-overlay" :class="{ show: showThemeDrawer }" @click="closeThemeDrawer"></div>

    <!-- 换肤抽屉面板 -->
    <div class="theme-drawer" :class="{ show: showThemeDrawer }">
      <div class="drawer-header">
        <span class="drawer-title">
          <i class="el-icon-magic-stick"></i> 主题换肤
        </span>
        <i class="el-icon-close drawer-close" @click="closeThemeDrawer"></i>
      </div>
      <div class="drawer-body">
        <p class="drawer-desc">选择你喜欢的主题风格，即时预览效果</p>

        <!-- 主题色块列表 -->
        <div class="theme-grid">
          <div v-for="theme in themes" :key="theme.key" class="theme-card"
            :class="{ active: currentTheme === theme.key }" @click="selectTheme(theme.key)">
            <!-- 预览色块 -->
            <div class="theme-preview">
              <div class="preview-nav" :style="{ background: '#fff' }">
                <div class="preview-logo" :style="{ background: theme.primary }"></div>
                <div class="preview-nav-dots">
                  <span :style="{ background: theme.navActive }"></span>
                  <span :style="{ background: '#e0e0e0' }"></span>
                  <span :style="{ background: '#e0e0e0' }"></span>
                </div>
              </div>
              <div class="preview-content" :style="{ background: theme.bgPage }">
                <div class="preview-card">
                  <div class="preview-bar" :style="{ background: theme.primary }"></div>
                  <div class="preview-line"></div>
                  <div class="preview-line short"></div>
                </div>
                <div class="preview-btn" :style="{ background: theme.primary }"></div>
              </div>
            </div>
            <!-- 主题名称和选中标记 -->
            <div class="theme-label">
              <span class="theme-name">{{ theme.name }}</span>
              <span v-if="currentTheme === theme.key" class="theme-check" :style="{ background: theme.primary }">
                <i class="el-icon-check"></i>
              </span>
            </div>
            <!-- 主题色板 -->
            <div class="theme-palette">
              <span v-for="(c, i) in theme.previewColors" :key="i" class="palette-dot"
                :style="{ background: c }"></span>
            </div>
          </div>
        </div>

        <!-- 自定义主色 -->

        <!-- 字体大小 -->
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="resetTheme">恢复默认</el-button>
        <el-button size="small" type="primary" @click="closeThemeDrawer">完成</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showSuperVipBenefitsDialog" width="460px" custom-class="super-vip-benefits-dialog"
      :show-close="false" append-to-body>
      <div v-loading="superVipBenefitsLoading" class="super-vip-benefits">
        <section class="super-vip-hero">
          <button type="button" class="super-vip-dialog-close" aria-label="关闭权益卡详情"
            @click="showSuperVipBenefitsDialog = false">
            <i class="el-icon-close" aria-hidden="true"></i>
          </button>
          <div class="super-vip-status"><span></span>权益卡已开通</div>
          <div class="super-vip-hero-main">
            <div class="super-vip-hero-copy">
              <h3>百工人服权益卡 <strong>VIP</strong></h3>
              <p v-if="superVipValidityText">有效期1年：{{ superVipValidityText }}</p>
            </div>
            <svg class="super-vip-mark" viewBox="0 0 96 108" aria-hidden="true">
              <path d="M48 4 90 28v52L48 104 6 80V28Z" />
              <path d="M48 20 76 36v36L48 88 20 72V36Z" />
              <path d="M48 35 63 44v19L48 72 33 63V44Z" />
            </svg>
          </div>
        </section>

        <section class="super-vip-rights" aria-labelledby="super-vip-rights-title">
          <header class="super-vip-rights-header">
            <h4 id="super-vip-rights-title">功能权益</h4>
            <button type="button" class="super-vip-invoice-link" @click="openSuperVipInvoice">
              <i class="el-icon-document" aria-hidden="true"></i>
              <span>查看发票</span>
            </button>
          </header>
          <table class="super-vip-comparison-table">
            <thead>
              <tr>
                <th scope="col">功能权益</th>
                <th scope="col">普通用户</th>
                <th scope="col">权益用户</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">百工市场人员池</th>
                <td>100 人</td>
                <td>所有人员</td>
              </tr>
              <tr>
                <th scope="row">用工风险提醒</th>
                <td>无</td>
                <td>智能风险分析</td>
              </tr>
              <!-- <tr>
                <th scope="row">项目用工管理</th>
                <td>基础版</td>
                <td>高级版</td>
              </tr>
              <tr>
                <th scope="row">数据报表导出</th>
                <td>按月导出</td>
                <td>无限导出</td>
              </tr>
              <tr>
                <th scope="row">专属客服通道</th>
                <td>无</td>
                <td><span class="super-vip-priority">优先响应</span></td>
              </tr> -->
            </tbody>
          </table>
        </section>
        <p class="super-vip-note">权益卡有效期内可享受以上全部权益，到期后权益将恢复为普通用户</p>
      </div>
    </el-dialog>
    <!-- 行业岗位设置全屏弹框 -->
    <IndustryPosition :visible.sync="showIndustryDialog" @confirm="onIndustryConfirm" />
    <InvoiceSettingsDialog :visible.sync="showInvoiceSettingsDialog" :invoice-info="userInfo.company" :saving="invoiceSettingsSaving" @save="handleInvoiceSettingsSave" />
  </div>
</template>

<script>
import { THEMES } from '@/store/modules/app'
import { mapActions, mapGetters } from 'vuex'
import { syncRoutesFromMenuTree } from '@/router'
import IndustryPosition from '@/components/IndustryPosition/index.vue'
import LegalAuthQrDialog from '@/components/LegalAuthQrDialog.vue'
import RealNameAuthQrDialog from '@/components/RealNameAuthQrDialog.vue'
import InvoiceSettingsDialog from './InvoiceSettingsDialog.vue'
import { downloadByUrl } from '@/utils/fileHelper'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import visitGuideBackground from '@/assets/img/visitGuide1.png'
import visitGuidePerson from '@/assets/img/visitGuide2.png'

export default {
  name: 'TopNav',
  components: { IndustryPosition, LegalAuthQrDialog, RealNameAuthQrDialog, InvoiceSettingsDialog, ElImageViewer },
  data() {
    return {
      customerServiceVisible: false,
      licensePreviewVisible: false,
      licensePreviewUrl: '',
      customerServiceReplying: false,
      customerServiceReplyTimer: null,
      customerServiceDragging: false,
      customerServicePreviousUserSelect: '',
      customerServicePosition: {
        left: null,
        top: null
      },
      customerServiceDragOffset: {
        x: 0,
        y: 0
      },
      customerServiceMessages: [
        {
          type: 'service',
          content: '您好，我是企业服务助手。请选择下方常见问题，我会立即为您解答。'
        }
      ],
      customerServiceQuestions: [
        {
          id: 1,
          question: '如何进行企业认证？',
          answer: '点击“头像”进入企业认证页面，按提示上传营业执照并填写企业信息，提交后等待审核即可。'
        },
        {
          id: 2,
          question: '如何发布用工需求？',
          answer: '进入首页点击快速制单入口，选择用工类型，填写岗位、人数和服务时间后提交需求。'
        },
        {
          id: 3,
          question: '如何查看订单进度？',
          answer: '进入首页订单中心，可查看待确认、待支付、领取中、已完成和已取消等订单状态。'
        },
        {
          id: 4,
          question: '企业钱包如何充值？',
          answer: '点击“头像 - 企业钱包”，选择充值方式，并按照页面提示完成充值操作。'
        },
        {
          id: 5,
          question: '如何申请开票？',
          answer: '在首页订单中心找到对应订单，点击“去开票”，核对基础信息、发票抬头和发票种类后提交申请。'
        },
        {
          id: 6,
          question: '如何添加管理员？',
          answer: '进入“配置中心 - 管理员管理”，点击添加管理员，填写姓名、账号、角色及管理范围后提交。'
        },
        {
          id: 7,
          question: '如何进行多个企业认证信息？',
          answer: '点击“头像”进入企业认证页面”，在企业基础信息中 认证其他企业的信息，并提交。'
        },
        {
          id: 8,
          question: '忘记登录密码怎么办？',
          answer: '点击“头像”，点击“修改密码”，按照提示完成密码重置。'
        }
      ],
      navItems: [
        { name: '首页', badge: 0, path: '/home', matchPath: '/home', children: [] },
        // {
        //   name: '工作台', badge: 0, path: '/workbench/dashboard', matchPath: '/workbench',
        //   children: [
        //     { name: 'Dashboard', title: '工作台概览', path: '/workbench/dashboard' },
        //     { name: 'Tasks', title: '我的任务', path: '/workbench/tasks' },
        //     { name: 'Schedule', title: '日程安排', path: '/workbench/schedule' }
        //   ]
        // },
        {
          name: '用工管理', badge: 0, path: '/employment/self?contract_type=5&type=self', matchPath: '/employment',
          // children: [
          //   { name: 'SelfEmployee', title: '自有员工', path: '/employment/self?contract_type=5' },
          //   { name: 'FlexibleEmployee', title: '易匠通用工', path: '/employment/flexible' },
          //   { name: 'PartnerMerchant', title: '合作商户', path: '/employment/partner' },
          //   { name: 'LaborDispatch', title: '劳务派遣', path: '/employment/dispatch?contract_type=4' },
          //   { name: 'StudentPartTime', title: '在校兼职', path: '/employment/student?contract_type=3' },
          //   { name: 'BusinessOutsource', title: '业务外包', path: '/employment/outsource?contract_type=2' },
          //   { name: 'NonFullTime', title: '非全日制用工', path: '/employment/nonfulltime?contract_type=3' },
          //   { name: 'RetireRehire', title: '退休返聘', path: '/employment/retire?contract_type=6' }
          // ]
        },
        {
          name: '工作台', badge: 0, path: '/workbench/workOrderCenter', matchPath: '/workbench',
        },
        {
          name: '消息中心', badge: 0, path: '/message/list', matchPath: '/message',
          // children: [
          //   { name: 'List', title: '消息列表', path: '/message/list' },
          //   // { name: 'Notification', title: '系统通知', path: '/message/notification' },
          //   // { name: 'Announcement', title: '公告中心', path: '/message/announcement' }
          // ]
        },
        {
          name: '风控中心', badge: 0, path: '/risk/control', matchPath: '/risk',
          //   // children: [
          //   //   { name: 'Control', title: '风控管理', path: '/risk/control' },
          //   //   { name: 'Warning', title: '风险预警', path: '/risk/warning' },
          //   //   { name: 'Audit', title: '审计日志', path: '/risk/audit' }
          //   // ]
        },
        {
          name: '配置中心', badge: 0, path: '/config/basic', matchPath: '/config',
          children: [
            { name: 'Basic', title: '组织管理', path: '/config/basic' },
            { name: 'ServiceProviderEntity', title: '服务商主体', path: '/config/signing-entity' },
            // { name: 'Permission', title: '权限管理', path: '/config/permission' },
            // { name: 'System', title: '系统设置', path: '/config/system' },
            // { name: 'SigningEntity', title: '服务商主体', path: '/config/signing-entity' },
            // { name: 'AccountManagement', title: '账户管理', path: '/config/account-management' },
          ]
        }
      ],
      allNavItems: [],
      subMenuItems: [],
      showSubMenu: false,
      dropdownVisible: false,
      companyDropdownVisible: false,
      showThemeDrawer: false,
      themes: THEMES,
      customColor: '#ED6C00',
      fontSize: localStorage.getItem('fontSize') || 'default',
      profileLoaded: false,
      firstVisitGuide: null,
      firstVisitGuideStep: null,
      firstVisitGuideCutoutObserver: null,
      firstVisitGuideDismissed: false,
      completingFirstVisitGuide: false,
      unverifiedGuideShown: false,
      showUnverifiedDialog: false,
      showCertDialog: false,
      showPwdDialog: false,
      showCertifiedDialog: false,
      showIndustryDialog: false,
      showInvoiceSettingsDialog: false,
      invoiceSettingsLoading: false,
      invoiceSettingsSaving: false,
      showQrDialog: false,
      showRealNameQrDialog: false,
      showSuperVipBenefitsDialog: false,
      superVipBenefitsLoading: false,
      superVipDetail: {},
      superVipInfoLoaded: false,
      superVipInfoCacheKey: '',
      superVipInfoLoadingPromise: null,
      superVipInfoLoadingCacheKey: '',
      certificationLoading: false,
      certViewMode: false,
      legalCertMode: false,
      pendingCertParams: null,
      certForm: {
        companyName: '',
        creditCode: '',
        card_name: '',
        card_no: '',
        authMethod: 'legal',
        adminName: '',
        adminIdCard: '',
        agreed: false,
        licenseFileList: [],
        licenseFile: null,
        orgImage: '',
        region: [],
        detailAddress: '',
        bankNo: '',
        bankOpenAccount: '',
        // syncYjtHistoryData: false
      },
      regionOptions: [],
      licenseUploading: false,
      certSubmitting: false,
      certRules: {
        licenseFile: [{
          validator: (rule, value, callback) => {
            if (this.certForm.licenseFile || this.certForm.orgImage) {
              callback()
              return
            }
            callback(new Error('请上传营业执照'))
          }, trigger: 'change'
        }],
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        creditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        region: [{ required: true, type: 'array', min: 3, message: '请选择省市区', trigger: 'change' }],
        detailAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
        card_name: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
        card_no: [
          { required: true, message: '请输入法人身份证号', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{17}[\dXx]$)/,
            message: '请输入正确的法人身份证号',
            trigger: 'blur'
          }
        ]
      },
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.pwdForm.newPassword) {
                callback(new Error('两次输入的密码不一致'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ]
      },
      cardForm: {
        card_name: '',
        card_no: '',
      },
      cardRules: {
        card_name: [{ required: true, message: '请输入身份证姓名', trigger: 'blur' }],
        card_no: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{17}[\dXx]$)/,
            message: '请输入正确的身份证号码',
            trigger: 'blur'
          }
        ],
      },
      companyList: [],
      default_company_id: "",
      companyName: "",
      contractParty: "",
      userInfo: {
        member: {},
        company: {},
        user: {},
        project: {}
      },
      wydToken: ''
    }
  },
  computed: {
    ...mapGetters(['messageStatistics']),
    userRole() {
      return this.$store.getters.userRole
    },
    activeNav() {
      return this.$store.getters.activeNav
    },
    currentTheme() {
      return this.$store.getters.themeKey
    },
    currentThemeName() {
      const t = THEMES.find(t => t.key === this.currentTheme)
      return t ? t.name : '默认'
    },
    customerServicePanelStyle() {
      const { left, top } = this.customerServicePosition
      if (left === null || top === null) return {}
      return {
        left: `${left}px`,
        top: `${top}px`,
        right: 'auto',
        bottom: 'auto'
      }
    },
    /**
     * 是否实名认证  member.is_certification
     */
    isCertified() { // 法人认证
      return this.userInfo.company && this.userInfo.company.is_certification
    },
    needsLegalCertification() { // 实名认证
      return Number(this.userInfo.member && this.userInfo.member.is_certification) === 0
    },
    isCompanyCertified() {
      return this.certViewMode
    },
    isSuperVip() {
      return Number(this.userInfo.member && this.userInfo.member.super_vip) === 1
    },
    superVipExpireDate() {
      const detail = this.superVipDetail || {}
      const member = this.userInfo.member || {}
      return this.formatSuperVipDate(detail.vip_expire_after || member.super_vip_expire_after)
    },
    superVipStartDate() {
      const detail = this.superVipDetail || {}
      const member = this.userInfo.member || {}
      return this.formatSuperVipDate(detail.vip_expire_before || member.super_vip_expire_before)
    },
    superVipValidityText() {
      const start = this.superVipStartDate.replace(/\./g, '/')
      const end = this.superVipExpireDate.replace(/\./g, '/')
      if (start && end) return `${start} 至 ${end}`
      return end ? `至 ${end}` : ''
    },
    hasCompanyArea() {
      return this.companyList.length > 0 || !!this.companyName || !!(this.userInfo.company && this.userInfo.company.default_contract_main_name)
    }
  },
  methods: {
    ...mapActions('page', ['getMessageStatistics']),
    formatSuperVipDate(value) {
      if (!value) return ''
      const text = String(value)
      if (/^\d{8}$/.test(text)) {
        return `${text.slice(0, 4)}.${text.slice(4, 6)}.${text.slice(6, 8)}`
      }
      if (/^\d{10,13}$/.test(text)) {
        const timestamp = text.length === 10 ? Number(text) * 1000 : Number(text)
        const date = new Date(timestamp)
        if (!Number.isNaN(date.getTime())) {
          return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`
        }
      }
      return text.split(' ')[0].replace(/[-/]/g, '.')
    },
    async openSuperVipBenefits() {
      if (this.$refs.userDropdown && this.$refs.userDropdown.hide) this.$refs.userDropdown.hide()
      this.dropdownVisible = false
      this.showSuperVipBenefitsDialog = true
      const cacheKey = this.getSuperVipInfoCacheKey()
      if (this.superVipInfoLoaded && this.superVipInfoCacheKey === cacheKey) return
      this.superVipBenefitsLoading = true
      try {
        await this.loadSuperVipInfo()
      } catch (err) {
        this.$message.error(err.message || err.msg || '获取权益卡信息失败')
      } finally {
        this.superVipBenefitsLoading = false
      }
    },
    async openSuperVipInvoice() {
      this.superVipBenefitsLoading = true
      try {
        const detail = await this.loadSuperVipInfo()
        const invoiceItem = Array.isArray(detail.invoice_items) ? detail.invoice_items[0] : null
        const invoiceUrl = invoiceItem && invoiceItem.invoice_img_url
        if (!invoiceUrl) {
          this.$message.warning('暂无可下载的权益卡发票')
          return
        }
        downloadByUrl({
          url: invoiceUrl,
          fileName: invoiceUrl.split('/').pop()
        })
      } catch (err) {
        this.$message.error(err.message || err.msg || '获取权益卡发票失败')
      } finally {
        this.superVipBenefitsLoading = false
      }
    },
    onDropdownVisible(v) {
      this.dropdownVisible = v
      if (v && this.isSuperVip) {
        this.loadSuperVipInfo().catch(() => { })
      }
    },
    getSuperVipInfoCacheKey() {
      const member = this.userInfo.member || {}
      const company = this.userInfo.company || {}
      const project = this.userInfo.project || {}
      return [
        member.member_id || member.id || '',
        company.company_id || company.id || '',
        project.project_id || project.id || ''
      ].join(':')
    },
    async loadSuperVipInfo() {
      const cacheKey = this.getSuperVipInfoCacheKey()
      if (this.superVipInfoLoaded && this.superVipInfoCacheKey === cacheKey) {
        return this.superVipDetail
      }
      if (this.superVipInfoLoadingPromise && this.superVipInfoLoadingCacheKey === cacheKey) {
        return this.superVipInfoLoadingPromise
      }

      const request = this.$Api.getSuperVipInfo().then(res => {
        const result = res && res.code !== undefined ? res : res.data
        if (!result || result.code !== 200) {
          throw new Error((result && result.msg) || '获取权益卡信息失败')
        }
        const data = result.data || {}
        const detail = {
          ...(data.info || {}),
          ...(data.card || {}),
          ...(data.invoice_info || {}),
          ...(data.order || {})
        }
        if (this.getSuperVipInfoCacheKey() === cacheKey) {
          this.superVipDetail = detail
          this.superVipInfoCacheKey = cacheKey
          this.superVipInfoLoaded = true
        }
        return detail
      })
      this.superVipInfoLoadingPromise = request
      this.superVipInfoLoadingCacheKey = cacheKey
      try {
        return await request
      } finally {
        if (this.superVipInfoLoadingPromise === request) {
          this.superVipInfoLoadingPromise = null
          this.superVipInfoLoadingCacheKey = ''
        }
      }
    },
    goHome() {
      this.$router.push('/home')
    },
    contactService() {
      this.customerServiceVisible = !this.customerServiceVisible
      if (this.customerServiceVisible) {
        this.$nextTick(() => {
          this.constrainCustomerServicePosition()
          this.scrollCustomerServiceToBottom()
        })
      } else {
        this.stopCustomerServiceDrag()
      }
    },
    closeCustomerService() {
      this.stopCustomerServiceDrag()
      this.customerServiceVisible = false
    },
    startCustomerServiceDrag(event) {
      if (event.button !== 0 || event.target.closest('.customer-service-action')) return
      const panel = this.$refs.customerServicePanel
      if (!panel) return
      const rect = panel.getBoundingClientRect()
      this.customerServiceDragging = true
      this.customerServiceDragOffset = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
      }
      document.addEventListener('mousemove', this.moveCustomerServicePanel)
      document.addEventListener('mouseup', this.stopCustomerServiceDrag)
      this.customerServicePreviousUserSelect = document.body.style.userSelect
      document.body.style.userSelect = 'none'
      event.preventDefault()
    },
    moveCustomerServicePanel(event) {
      if (!this.customerServiceDragging) return
      const panel = this.$refs.customerServicePanel
      if (!panel) return
      const rect = panel.getBoundingClientRect()
      const edgeGap = 8
      const maxLeft = Math.max(edgeGap, window.innerWidth - rect.width - edgeGap)
      const maxTop = Math.max(edgeGap, window.innerHeight - rect.height - edgeGap)
      this.customerServicePosition = {
        left: Math.min(Math.max(edgeGap, event.clientX - this.customerServiceDragOffset.x), maxLeft),
        top: Math.min(Math.max(edgeGap, event.clientY - this.customerServiceDragOffset.y), maxTop)
      }
    },
    stopCustomerServiceDrag() {
      const wasDragging = this.customerServiceDragging
      this.customerServiceDragging = false
      document.removeEventListener('mousemove', this.moveCustomerServicePanel)
      document.removeEventListener('mouseup', this.stopCustomerServiceDrag)
      if (wasDragging) {
        document.body.style.userSelect = this.customerServicePreviousUserSelect
      }
    },
    constrainCustomerServicePosition() {
      if (this.customerServicePosition.left === null || this.customerServicePosition.top === null) return
      const panel = this.$refs.customerServicePanel
      if (!panel) return
      const rect = panel.getBoundingClientRect()
      const edgeGap = 8
      this.customerServicePosition = {
        left: Math.min(Math.max(edgeGap, this.customerServicePosition.left), Math.max(edgeGap, window.innerWidth - rect.width - edgeGap)),
        top: Math.min(Math.max(edgeGap, this.customerServicePosition.top), Math.max(edgeGap, window.innerHeight - rect.height - edgeGap))
      }
    },
    selectCustomerQuestion(item) {
      if (!item || this.customerServiceReplying) return
      this.customerServiceMessages.push({
        type: 'user',
        content: item.question
      })
      this.customerServiceReplying = true
      this.$nextTick(this.scrollCustomerServiceToBottom)
      this.customerServiceReplyTimer = setTimeout(() => {
        this.customerServiceMessages.push({
          type: 'service',
          content: item.answer
        })
        this.customerServiceReplying = false
        this.customerServiceReplyTimer = null
        this.$nextTick(this.scrollCustomerServiceToBottom)
      }, 450)
    },
    resetCustomerService() {
      if (this.customerServiceReplyTimer) {
        clearTimeout(this.customerServiceReplyTimer)
        this.customerServiceReplyTimer = null
      }
      this.customerServiceReplying = false
      this.customerServiceMessages = [
        {
          type: 'service',
          content: '您好，我是企业服务助手。请选择下方常见问题，我会立即为您解答。'
        }
      ]
      this.$nextTick(this.scrollCustomerServiceToBottom)
    },
    scrollCustomerServiceToBottom() {
      const messageBox = this.$refs.customerServiceMessages
      if (messageBox) {
        messageBox.scrollTop = messageBox.scrollHeight
      }
    },
    onCompanyDropdownVisible(v) {
      console.log('CompanyDropdownVisible', v)
      this.companyDropdownVisible = v
    },
    async handleCompanyCommand(company) {
      if (company === 'addCompany') {
        this.openAddCompanyDialog()
        return
      }
      if (!company || !company.company_id) return
      try {
        const res = await this.$Api.switchCompany({ company_id: company.company_id })
        const result = res && res.code !== undefined ? res : res.data
        if (result.code === 200) {
          this.$message.success(`已切换到「${company.company_name}」`)
          await this.getProfile()
          if (this.$route.path !== '/home') {
            await this.$router.push('/home')
          }
          await this.checkSceneWorkAfterCompanySwitch()
          this.$emit('company-change')
        } else {
          this.$message.error(result.msg || '切换公司失败')
        }
      } catch (err) {
        this.$message.error(err.message || err.msg || '切换公司失败')
      }
    },
    async checkSceneWorkAfterCompanySwitch() {
      try {
        const res = await this.$Api.getSceneWork()
        const result = res && res.code !== undefined ? res : res.data
        const data = result && result.data
        if (result && result.code === 200 && data && typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0) {
          this.showIndustryDialog = true
        }
      } catch (err) {
        console.error('getSceneWork failed', err)
      }
    },
    handleUserCommand(command) {
      if (command === 'logout') {
        this.handleLogout()
      } else if (command === 'theme') {
        this.openThemeDrawer()
      } else if (command === 'profile') {
        this.$message.info('个人中心功能开发中')
      } else if (command === 'settings') {
        this.$message.info('账号设置功能开发中')
      } else if (command === 'certification') {
        this.openCertDialog()
      } else if (command === 'password') {
        this.showPwdDialog = true
      } else if (command === 'certified') {
        // 实名认证
        this.showCertifiedDialog = true
      } else if (command === 'wallet') {
        this.$router.push('/wallet')
      } else if (command === 'switchEntity') {
        this.$router.push('/config/signing-entity')
      } else if (command === 'industryPosition') {
        this.showIndustryDialog = true
      } else if (command === 'invoiceSettings') {
        return this.openInvoiceSettings()
      }
    },
    async openInvoiceSettings() {
      if (this.invoiceSettingsLoading) return
      this.invoiceSettingsLoading = true
      try {
        const res = await this.$Api.getProfile()
        if (res.code === 200) {
          this.applyProfileData(res.data)
          this.showInvoiceSettingsDialog = true
        } else {
          this.$message.error(res.msg || '获取开票信息失败')
        }
      } catch (error) {
        this.$message.error(error.message || '获取开票信息失败')
      } finally {
        this.invoiceSettingsLoading = false
      }
    },
    async handleInvoiceSettingsSave(form) {
      if (this.invoiceSettingsSaving) return
      const { company_name, org_code, contract_address, contract_mobile, bank_name, bank_number } = form
      const params = { company_name, org_code, contract_address, contract_mobile, bank_name, bank_number }
      this.invoiceSettingsSaving = true
      try {
        const res = await this.$Api.saveCompanyInfo(params)
        if (res.code === 200) {
          this.applyProfileData({ ...this.userInfo, company: { ...this.userInfo.company, ...params } })
          this.$message.success(res.msg || '保存成功')
          this.showInvoiceSettingsDialog = false
        } else {
          this.$message.error(res.msg || '保存开票信息失败')
        }
      } catch (error) {
        this.$message.error(error.message || '保存开票信息失败')
      } finally {
        this.invoiceSettingsSaving = false
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout').catch(() => null).finally(() => {
          this.$router.push('/login')
        })
      })
    },
    openThemeDrawer() {
      const t = THEMES.find(t => t.key === this.currentTheme)
      if (t) this.customColor = t.primary
      this.showThemeDrawer = true
    },
    closeThemeDrawer() {
      this.showThemeDrawer = false
    },
    selectTheme(key) {
      this.$store.commit('app/SET_THEME', key)
      this.$applyTheme(key)
      const t = THEMES.find(t => t.key === key)
      if (t) this.customColor = t.primary
      this.$message({ message: `已切换到「${t ? t.name : '默认'}」主题`, type: 'success', duration: 1500 })
    },
    applyCustomColor(color) {
      if (!color) return
      const root = document.documentElement
      function hexToRgb(hex) {
        const h = hex.replace('#', '')
        const r = parseInt(h.substring(0, 2), 16)
        const g = parseInt(h.substring(2, 4), 16)
        const b = parseInt(h.substring(4, 6), 16)
        return `${r}, ${g}, ${b}`
      }
      root.style.setProperty('--primary', color)
      root.style.setProperty('--primary-rgb', hexToRgb(color))
      root.style.setProperty('--primary-hover', color + 'cc')
      root.style.setProperty('--nav-active', color)
      this.$store.commit('app/SET_THEME', 'custom')
      localStorage.setItem('customPrimaryColor', color)
    },
    applyFontSize(size) {
      const sizeMap = { small: '13px', default: '14px', large: '15px' }
      document.documentElement.style.setProperty('--base-font-size', sizeMap[size] || '14px')
      localStorage.setItem('fontSize', size)
    },
    resetTheme() {
      this.selectTheme('default')
      this.fontSize = 'default'
      this.applyFontSize('default')
    },
    hasCertifiedCompany() {
      return Array.isArray(this.companyList) && this.companyList.length > 0
    },
    handleUnverifiedGuide() {
      if (!this.profileLoaded || this.unverifiedGuideShown || this.hasCertifiedCompany()) {
        if (this.hasCertifiedCompany()) {
          this.showUnverifiedDialog = false
        }
        return
      }
      this.showUnverifiedDialog = true
      this.unverifiedGuideShown = true
    },
    // 新用户引导弹框
    startFirstVisitGuide() {
      if (!this.profileLoaded || this.showUnverifiedDialog || this.showIndustryDialog || this.firstVisitGuideDismissed) return
      if (this.userInfo.show_guide !== true) return
      if (this.firstVisitGuideStep === null) {
        this.firstVisitGuideStep = 0
      }
      this.showFirstVisitGuideStep()
    },
    updateFirstVisitGuideOrganizationCutout() {
      const organizationTab = document.getElementById('config-guide-organization-tab')
      const overlayPath = document.querySelector('.driver-overlay path')
      if (!organizationTab || !overlayPath) return
      const rect = organizationTab.getBoundingClientRect()
      const padding = 8
      const radius = 4
      const x = rect.left - padding
      const y = rect.top - padding
      const width = rect.width + padding * 2
      const height = rect.height + padding * 2
      const cutout = ` M${x + radius},${y} H${x + width - radius} Q${x + width},${y} ${x + width},${y + radius} V${y + height - radius} Q${x + width},${y + height} ${x + width - radius},${y + height} H${x + radius} Q${x},${y + height} ${x},${y + height - radius} V${y + radius} Q${x},${y} ${x + radius},${y} Z`
      const path = overlayPath.getAttribute('d') || ''
      const previousCutout = overlayPath.dataset.organizationGuideCutout || ''
      const basePath = previousCutout && path.endsWith(previousCutout)
        ? path.slice(0, -previousCutout.length)
        : path
      if (path === basePath + cutout) return
      overlayPath.dataset.organizationGuideCutout = cutout
      overlayPath.setAttribute('fill-rule', 'evenodd')
      overlayPath.setAttribute('d', basePath + cutout)
    },
    showFirstVisitGuideStep() {
      const step = this.firstVisitGuideStep
      if (step === null || this.firstVisitGuide) return
      const routeMatches = step === 0 ? true
        : step < 3 ? this.$route.path === '/config/basic'
          : this.$route.path === '/config/signing-entity'
      if (!routeMatches) return
      const targets = [
        'config-center-guide-target',
        'config-guide-personnel-tab',
        'config-guide-add-personnel',
        'config-guide-service-tab',
        'config-guide-service-actions'
      ]
      const target = document.getElementById(targets[step])
      if (!target) return
      const titles = [
        '配置服务商主体及支付角色',
        '添加人事与财务角色',
        '新增人员',
        '服务商主体',
        '选择用工类型与新增服务商'
      ]
      const descriptions = [
        '如需为自有员工办理业务，请先配置服务商主体、人事及财务角色，以确保业务流程中的支付正常进行。未完成配置可能影响后续支付操作。',
        '请配置人事、财务角色：人事制作工资单，财务审核并支付工资，保障薪资支付流程顺利进行',
        '点击「新增」，添加相关人员并分配人事、财务角色，完成自有员工薪资流程的角色配置',
        '在这里查看和管理服务商主体信息',
        '请根据实际业务选择用工类型，并点击「新增服务商」填写主体及签约信息，完成对应服务商的配置'
      ]
      let guide
      guide = driver({
        overlayColor: '#000',
        overlayOpacity: 0.55,
        overlayClickBehavior: 'none',
        allowClose: false,
        allowScroll: false,
        allowKeyboardControl: false,
        disableActiveInteraction: true,
        stagePadding: step === 0 ? 0 : 4,
        stageRadius: 4,
        popoverOffset: step === 0 ? 95 : 10,
        popoverClass: 'config-first-visit-popover',
        showButtons: [],
        onPopoverRender: (popover) => {
          popover.wrapper.classList.add(`config-guide-step-${step}`)
          popover.wrapper.style.display = 'flex'
          if (step === 0) popover.wrapper.style.transform = 'translate(189px, -17px)'
          if (step === 1) popover.wrapper.style.transform = 'translate(-128px, 40px)'
          if (step === 2) popover.wrapper.style.transform = 'translateY(100px)'
          if (step === 3) popover.wrapper.style.transform = 'translateY(50px)'
          if (step === 4) popover.wrapper.style.transform = 'translateY(100px)'
          const background = document.createElement('img')
          background.className = 'config-first-visit-background'
          background.src = visitGuideBackground
          background.alt = ''
          background.setAttribute('aria-hidden', 'true')
          popover.wrapper.prepend(background)
          const illustration = document.createElement('div')
          illustration.className = 'config-first-visit-illustration'
          illustration.setAttribute('aria-hidden', 'true')
          const person = document.createElement('img')
          person.src = visitGuidePerson
          person.alt = ''
          illustration.appendChild(person)
          popover.wrapper.prepend(illustration)
          const actions = document.createElement('div')
          actions.className = 'config-first-visit-actions'
          const skip = document.createElement('button')
          skip.type = 'button'
          skip.className = 'config-first-visit-skip'
          skip.textContent = step === 0 ? '跳过' : `跳过 ${step}/4`
          // skip.addEventListener('click', () => this.finishFirstVisitGuide())
          skip.addEventListener('click', async () => {
            if (this.completingFirstVisitGuide) return
            skip.disabled = true
            const completed = await this.completeFirstVisitGuide()
            if (!completed) skip.disabled = false
          })
          actions.appendChild(skip)
          if (step > 1) {
            const previous = document.createElement('button')
            previous.type = 'button'
            previous.className = 'config-first-visit-previous'
            previous.textContent = '上一步'
            previous.addEventListener('click', () => this.changeFirstVisitGuideStep(step - 1))
            actions.appendChild(previous)
          }
          const next = document.createElement('button')
          next.type = 'button'
          next.className = 'config-first-visit-next'
          next.textContent = step === 0 ? '前往配置' : step === 4 ? '我知道了' : '下一步'
          next.addEventListener('click', async () => {
            if (step === 4) {
              if (this.completingFirstVisitGuide) return
              next.disabled = true
              const completed = await this.completeFirstVisitGuide()
              if (!completed) next.disabled = false
            } else {
              this.changeFirstVisitGuideStep(step + 1)
            }
          })
          actions.appendChild(next)
          popover.wrapper.appendChild(actions)
        },
        onHighlighted: () => {
          if (step !== 1) return
          this.updateFirstVisitGuideOrganizationCutout()
          const overlayPath = document.querySelector('.driver-overlay path')
          if (!overlayPath) return
          this.firstVisitGuideCutoutObserver = new MutationObserver(() => this.updateFirstVisitGuideOrganizationCutout())
          this.firstVisitGuideCutoutObserver.observe(overlayPath, { attributes: true, attributeFilter: ['d'] })
        },
        onDestroyed: () => {
          if (this.firstVisitGuideCutoutObserver) this.firstVisitGuideCutoutObserver.disconnect()
          this.firstVisitGuideCutoutObserver = null
          if (this.firstVisitGuide === guide) this.firstVisitGuide = null
        }
      })
      this.firstVisitGuide = guide
      guide.highlight({
        element: target,
        popover: {
          title: titles[step],
          description: descriptions[step],
          side: step === 1 ? 'right' : 'bottom',
          align: step === 1 || step === 3 ? 'start' : 'end'
        }
      })
    },
    changeFirstVisitGuideStep(step) {
      if (this.firstVisitGuide) this.firstVisitGuide.destroy()
      this.firstVisitGuideStep = step
      if (step < 3 && this.$route.path !== '/config/basic') {
        this.$router.push({ path: '/config/basic', query: { guide: 'personnel' } })
      } else if (step >= 3 && this.$route.path !== '/config/signing-entity') {
        this.$router.push({ path: '/config/signing-entity', query: { guide: 'service-provider' } })
      } else {
        this.$nextTick(() => this.showFirstVisitGuideStep())
      }
    },
    async completeFirstVisitGuide() {
      if (this.completingFirstVisitGuide) return false
      this.completingFirstVisitGuide = true
      try {
        const result = await this.$Api.completeGuide()
        if (result.code !== 200) {
          this.$message.error(result.msg || '完成引导失败')
          return false
        }
        this.applyProfileData({ ...this.userInfo, show_guide: false })
        this.finishFirstVisitGuide()
        return true
      } catch (error) {
        this.$message.error(error.message || '完成引导失败')
        return false
      } finally {
        this.completingFirstVisitGuide = false
      }
    },
    finishFirstVisitGuide() {
      this.firstVisitGuideDismissed = true
      if (this.firstVisitGuide) this.firstVisitGuide.destroy()
      this.firstVisitGuide = null
      this.firstVisitGuideStep = null
      if (this.$route.query.guide) {
        const query = { ...this.$route.query }
        delete query.guide
        this.$router.replace({ path: this.$route.path, query })
      }
    },
    skipUnverifiedGuide() {
      this.showUnverifiedDialog = false
      this.unverifiedGuideShown = true
    },
    startUnverifiedCertification() {
      this.showUnverifiedDialog = false
      this.unverifiedGuideShown = true
      this.openCertEditMode()
    },
    openAddCompanyDialog() {
      this.showCertDialog = true
      this.startCertOtherCompany()
    },
    async openCertDialog() {
      if (this.certificationLoading) return
      this.certificationLoading = true
      this.legalCertMode = false
      this.licenseUploading = false
      this.certSubmitting = false
      try {
        const res = await this.$Api.getCompanyInfo({})
        const result = res && res.code !== undefined ? res : res.data
        if (!result || result.code !== 200) {
          this.openCertEditMode()
          return
        }
        const detail = result.data || {}
        this.certViewMode = this.hasCompanyInfo(detail)
        this.fillCertForm(detail)
        this.loadRegionOptions()
        this.showCertDialog = true
        this.$nextTick(() => {
          this.$refs.certForm && this.$refs.certForm.clearValidate()
        })
      } catch (err) {
        this.$message.error(err.message || err.msg || '获取企业信息失败')
      } finally {
        this.certificationLoading = false
      }
    },
    openCertEditMode() {
      this.showCertDialog = true
      this.startCertOtherCompany()
    },
    hasCompanyInfo(detail) {
      if (!detail || Object.prototype.toString.call(detail) !== '[object Object]') {
        return false
      }
      return Object.keys(detail).some(key => {
        const value = detail[key]
        if (value === null || value === undefined || value === '') return false
        if (Array.isArray(value)) return value.length > 0
        if (typeof value === 'object') return Object.keys(value).length > 0
        return true
      })
    },
    fillCertForm(detail) {
      const region = []
      const provinceId = detail.province_id || detail.province
      const cityId = detail.city_id || detail.city
      const regionId = detail.region_id || detail.district_id || detail.area_id || detail.region
      if (provinceId && cityId && regionId) {
        region.push(provinceId, cityId, regionId)
      }
      this.certForm.companyName = detail.company_name || ''
      this.certForm.creditCode = detail.org_code || detail.credit_code || ''
      this.certForm.card_name = detail.card_name || detail.card_name || detail.legal_person || detail.legal_name || ''
      this.certForm.card_no = detail.card_no || detail.card_no || ''
      this.certForm.authMethod = 'legal'
      this.certForm.adminName = ''
      this.certForm.adminIdCard = ''
      this.certForm.agreed = false
      this.certForm.licenseFile = null
      this.certForm.orgImage = detail.org_image || ''
      this.certForm.licenseFileList = detail.org_image ? [{
        name: '营业执照',
        url: detail.org_image
      }] : []
      this.certForm.region = region
      this.certForm.detailAddress = detail.address || ''
      this.certForm.bankNo = detail.bank_no || ''
      this.certForm.bankOpenAccount = detail.bank_open_account || ''
      // this.certForm.syncYjtHistoryData = false
    },
    startCertOtherCompany() {
      this.certViewMode = false
      this.legalCertMode = false
      this.wydToken = ''
      this.certForm.companyName = ''
      this.certForm.creditCode = ''
      this.certForm.card_name = ''
      this.certForm.card_no = ''
      this.certForm.authMethod = 'legal'
      this.certForm.adminName = ''
      this.certForm.adminIdCard = ''
      this.certForm.agreed = false
      this.certForm.licenseFileList = []
      this.certForm.licenseFile = null
      this.certForm.orgImage = ''
      this.certForm.region = []
      this.certForm.detailAddress = ''
      this.certForm.bankNo = ''
      this.certForm.bankOpenAccount = ''
      // this.certForm.syncYjtHistoryData = false
      this.licenseUploading = false
      this.certSubmitting = false
      this.loadRegionOptions()
      this.$nextTick(() => {
        this.$refs.certForm && this.$refs.certForm.clearValidate()
      })
    },
    startLegalCertification() {
      this.legalCertMode = true
      this.certForm.authMethod = 'legal'
      this.$nextTick(() => {
        this.$refs.certForm && this.$refs.certForm.clearValidate(['card_name', 'card_no'])
      })
    },
    cancelLegalCertification() {
      this.legalCertMode = false
      this.$nextTick(() => {
        this.$refs.certForm && this.$refs.certForm.clearValidate(['card_name', 'card_no'])
      })
    },
    submitLegalCertification() {
      if (this.certSubmitting || !this.$refs.certForm) return
      this.$refs.certForm.validateField('card_name', (nameError) => {
        if (nameError) return
        this.$refs.certForm.validateField('card_no', (cardNoError) => {
          if (cardNoError) return
          const [provinceId, cityId, regionId] = this.certForm.region
          this.openQrDialog({
            org_image: this.certForm.orgImage,
            province_id: provinceId,
            city_id: cityId,
            region_id: regionId,
            bank_no: this.certForm.bankNo,
            bank_open_account: this.certForm.bankOpenAccount,
            card_name: this.certForm.card_name,
            card_no: this.certForm.card_no,
            auth_type: 2
          })
        })
      })
    },
    loadRegionOptions() {
      if (this.regionOptions.length > 0) return
      const localRegion = JSON.parse(localStorage.getItem('region') || '[]')
      if (localRegion.length > 0) {
        this.regionOptions = localRegion
        return
      }
      this.$Api.getAllRegion().then((res) => {
        const result = res && res.code !== undefined ? res : res.data
        if (result.code === 200) {
          this.regionOptions = (result.data && result.data.list) || []
        }
      })
    },
    handleLicenseChange(file) {
      const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.raw.type)
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片')
        this.certForm.licenseFileList = []
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        this.certForm.licenseFileList = []
        return false
      }
      this.certForm.licenseFile = file.raw
      this.certForm.licenseFileList = [file]
      this.$nextTick(() => {
        this.$refs.certForm && this.$refs.certForm.validateField('licenseFile')
      })
      this.validateBusinessLicense(file.raw)
    },
    handleLicensePreview(file) {
      const previewUrl = (file && file.url) || this.certForm.orgImage
      if (!previewUrl) {
        this.$message.warning('营业执照图片暂不可预览')
        return
      }
      this.licensePreviewUrl = previewUrl
      this.licensePreviewVisible = true
    },
    closeLicensePreview() {
      this.licensePreviewVisible = false
      this.licensePreviewUrl = ''
    },
    handleLicenseRemove() {
      this.closeLicensePreview()
      this.certForm.licenseFile = null
      this.certForm.licenseFileList = []
      this.certForm.orgImage = ''
      this.$nextTick(() => {
        this.$refs.certForm && this.$refs.certForm.validateField('licenseFile')
      })
    },
    validateBusinessLicense(file) {
      const formData = new FormData()
      formData.append('file', file)
      this.licenseUploading = true
      this.$Api.validationBusinessLicense(formData).then((res) => {
        const result = res && res.code !== undefined ? res : res.data
        if (result.code === 200) {
          const detail = result.data || {}
          this.certForm.companyName = detail.company_name
          this.certForm.creditCode = detail.org_code
          this.certForm.card_name = detail.card_name || detail.card_name || detail.legal_name || ''
          this.certForm.card_no = detail.card_no || detail.card_no || ''
          this.certForm.orgImage = detail.org_image
          this.certForm.detailAddress = detail.address
          this.$message.success(result.msg || '营业执照识别成功')
        } else {
          this.$message.error(result.msg || '营业执照识别失败')
        }
      }).catch(() => {
        this.$message.error('营业执照识别失败')
      }).finally(() => {
        this.licenseUploading = false
      })
    },
    showCommitment() {
      this.$alert('企业信息认证承诺书内容...', '企业信息认证承诺书', {
        confirmButtonText: '确定',
        type: 'info'
      })
    },
    submitCert() {
      this.$refs.certForm.validate((valid) => {
        if (!valid) return
        if (!this.certForm.licenseFile && !this.certForm.orgImage) {
          this.$message.warning('请上传营业执照')
          return
        }
        if (this.licenseUploading) {
          this.$message.warning('营业执照识别中，请稍后提交')
          return
        }
        if (!this.certForm.orgImage) {
          this.$message.warning('请先上传并识别营业执照')
          return
        }
        const [provinceId, cityId, regionId] = this.certForm.region
        const params = {
          org_image: this.certForm.orgImage,
          province_id: provinceId,
          city_id: cityId,
          region_id: regionId,
          bank_no: this.certForm.bankNo,
          bank_open_account: this.certForm.bankOpenAccount,
          card_name: this.certForm.authMethod === 'admin' ? '' : this.certForm.card_name,
          card_no: this.certForm.card_no,
          auth_type: this.certForm.authMethod === 'legal' ? 2 : 1
          // is_sync: this.certForm.syncYjtHistoryData ? 1 : 0
        }

        if (this.certForm.authMethod === 'legal') {
          if (!this.certForm.card_no) {
            this.$message.warning('请输入法人身份证号')
            return
          }
          this.openQrDialog(params)
          return
        }
        // if (!this.certForm.adminName || !this.certForm.adminIdCard) {
        //   this.$message.warning('请填写管理员姓名和身份证号')
        //   return
        // }
        this.submitCertification(params)
      })
    },
    submitCertification(params) {
      if (this.certSubmitting) return
      this.certSubmitting = true
      this.$Api.customerVerification(params).then(async (res) => {
        const result = res && res.code !== undefined ? res : res.data
        if (result.code === 200) {
          this.$message.success(result.msg || '注册信息提交成功')
          await this.getProfile()
          this.showCertDialog = false
          this.showIndustryDialog = true
        } else {
          this.$message.error(result.msg || '提交失败')
        }
      }).catch(() => {
        this.$message.error('提交失败')
      }).finally(() => {
        this.certSubmitting = false
      })
    },
    submitPwd() {
      this.$refs.pwdForm.validate((valid) => {
        if (!valid) return

        this.$Api.alterPassword({
          password: this.pwdForm.oldPassword,
          new_password: this.pwdForm.newPassword,
          confirm_password: this.pwdForm.confirmPassword,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success('密码修改成功')
            this.$router.push('/login')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.$message.error(err.msg)
        }).finally(() => {
          this.showPwdDialog = false
        })
      })
    },
    resetPwdForm() {
      this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
      this.$refs.pwdForm && this.$refs.pwdForm.clearValidate()
    },
    submitCard() {
      this.$refs.cardForm.validate((valid) => {
        if (!valid) return

        this.showRealNameQrDialog = true
      })
    },
    resetCardForm() {
      this.cardForm = { card_name: '', card_no: '' }
      this.$refs.cardForm && this.$refs.cardForm.clearValidate()
    },
    async onIndustryConfirm() {
      await this.getProfile()
    },
    openQrDialog(params) {
      const token = localStorage.getItem('token')
      if (!token) {
        this.$message.warning('登录信息已失效，请重新登录')
        return
      }

      this.wydToken = ''
      this.pendingCertParams = params
      this.showQrDialog = true
    },
    handleQrFaceCheckSuccess(message) {
      if (!this.pendingCertParams || this.certSubmitting) return
      this.handleLegalAuthSuccess(message)
      const params = {
        ...this.pendingCertParams,
        wyd_token: this.wydToken
      }
      this.pendingCertParams = null
      this.$message.success(message.msg || '法人核验成功')
      this.submitCertification(params)
    },
    async handleRealNameQrFaceCheckSuccess(message) {
      const data = message.data || {}
      const wydToken = message.wydToken || data.wydToken || message.wyd_token || data.wyd_token || this.wydToken

      const res = await this.$Api.identityVerification({
        ...this.cardForm,
        wyd_token: wydToken
      })
      if (res.code === 200) {
        this.$message.success(res.msg || '实名认证成功')
        await this.getProfile()
        this.showRealNameQrDialog = false
        this.showCertifiedDialog = false
      } else {
        this.$message.error(res.msg || '实名认证失败')
      }
    },
    handleNavClick(item) {
      this.subMenuItems = item.children || []
      this.showSubMenu = this.subMenuItems.length > 0
      if (item.path && this.$route.path !== item.path) {
        this.$router.push(item.path)
      }
      this.$store.commit('app/SET_ACTIVE_NAV', item.name)
    },
    handleSubNavClick(subItem) {
      if (this.$route.path !== subItem.path) this.$router.push(subItem.path)
    },
    filterNavItemsByRoutes() {
      const source = this.allNavItems.length ? this.allNavItems : this.navItems
      this.navItems = source.reduce((items, item) => {
        if (!this.$router.match(item.path).matched.length) return items
        const children = (item.children || []).filter(child => this.$router.match(child.path).matched.length)
        items.push({ ...item, children })
        return items
      }, [])
    },
    updateSubMenuByRoute() {
      const path = this.$route.path
      for (const item of this.navItems) {
        if (path.startsWith(item.matchPath)) {
          this.subMenuItems = item.children || []
          this.showSubMenu = this.subMenuItems.length > 0
          this.$store.commit('app/SET_ACTIVE_NAV', item.name)
          break
        }
      }
    },
    applyProfileData(profile) {
      const cacheUserInfo = localStorage.getItem("userInfo") && JSON.parse(localStorage.getItem("userInfo"))
      const data = profile || {}
      if (cacheUserInfo && cacheUserInfo.auth) {
        data.auth = cacheUserInfo.auth
      }
      if (cacheUserInfo && cacheUserInfo.menu_tree && data.menu_tree == null) {
        data.menu_tree = cacheUserInfo.menu_tree
      }
      const company = data.company || {}
      const companyList = company.companyList || []
      const defaultCompanyId = company.default_company_id || ''
      const currentCompany = companyList.find(v => String(v.company_id) === String(defaultCompanyId))
      this.userInfo = data;
      this.companyList = companyList;
      this.default_company_id = defaultCompanyId;
      this.companyName = currentCompany ? currentCompany.company_name : '';
      this.$store.commit('user/SET_USER_INFO', data)
      localStorage.setItem('userInfo', JSON.stringify(data))
      localStorage.setItem('default_company_id', defaultCompanyId)
      if (company.default_contract_main_id !== undefined) {
        localStorage.setItem('default_contract_main_id', JSON.stringify(company.default_contract_main_id))
      }
      if (company.default_project_id !== undefined) {
        localStorage.setItem('default_project_id', JSON.stringify(company.default_project_id))
      }
      if (this.companyName) {
        localStorage.setItem('companyName', this.companyName)
      } else {
        localStorage.removeItem('companyName')
      }
    },
    async getProfile() {
      // 获取用户信息
      let res = await this.$Api.getProfile();
      await this.getMessageStatistics();

      const result = res && res.code !== undefined ? res : res.data
      if (result.code === 200) {
        console.log("获取用户信息", result.data)
        this.applyProfileData(result.data)
        syncRoutesFromMenuTree(this.userInfo.menu_tree)
        this.filterNavItemsByRoutes()
        this.updateSubMenuByRoute()
        this.profileLoaded = true
        this.handleUnverifiedGuide()
        this.$nextTick(() => this.startFirstVisitGuide())
      }
      this.navItems.forEach(item => {
        if (item.name === '消息中心') {
          item.badge = Number(this.messageStatistics.reward_count) + Number(this.messageStatistics.recharge_count) + Number(this.messageStatistics.invoice_count)
        }
      })
    },
    handleLegalAuthSuccess(message = {}) {
      const data = message.data || {}
      this.wydToken = message.wydToken || data.wydToken || message.wyd_token || data.wyd_token || this.wydToken
    },
  },
  watch: {
    messageStatistics: {
      deep: true,
      handler(statistics) {
        const messageItem = this.navItems.find(item => item.name === '消息中心')
        if (messageItem) {
          messageItem.badge = Number(statistics.reward_count || 0) + Number(statistics.recharge_count || 0) + Number(statistics.invoice_count || 0)
        }
      }
    },
    '$route'(to, from) {
      this.updateSubMenuByRoute()
      if (this.firstVisitGuide) this.firstVisitGuide.destroy()
      // 监听菜单切换
      const toItem = this.navItems.find(item => to.path.startsWith(item.matchPath))
      const fromItem = this.navItems.find(item => from.path.startsWith(item.matchPath))
      if (toItem && (!fromItem || toItem.name !== fromItem.name)) {
        console.log('[菜单切换]', fromItem ? fromItem.name : '无', '->', toItem.name)
        this.getProfile()
        this.$emit('navChange', { to: toItem, from: fromItem, route: to })
      } else {
        this.$nextTick(() => this.startFirstVisitGuide())
      }
    },
    showQrDialog(val) {
      if (!val) this.pendingCertParams = null
    }
  },
  mounted() {
    window.addEventListener('resize', this.constrainCustomerServicePosition);
  },
  beforeDestroy() {
    if (this.firstVisitGuide) this.firstVisitGuide.destroy()
    this.$root.$off('profile-updated', this.applyProfileData)
    window.removeEventListener('resize', this.constrainCustomerServicePosition)
    this.stopCustomerServiceDrag()
    if (this.customerServiceReplyTimer) {
      clearTimeout(this.customerServiceReplyTimer)
      this.customerServiceReplyTimer = null
    }
  },
  created() {
    console.log("顶部菜单栏")
    this.allNavItems = this.navItems.map(item => ({
      ...item,
      children: (item.children || []).map(child => ({ ...child }))
    }))
    const cacheUserInfo = localStorage.getItem("userInfo") && JSON.parse(localStorage.getItem("userInfo"))
    if (cacheUserInfo) {
      this.applyProfileData(cacheUserInfo)
    }
    this.filterNavItemsByRoutes()
    this.getProfile()
    this.updateSubMenuByRoute()
    this.applyFontSize(this.fontSize)
    this.$root.$on('profile-updated', this.applyProfileData)
  }
}
</script>

<style lang="less" scoped>
.top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--nav-bg);
  box-shadow: var(--nav-shadow);
  position: sticky;
  top: 0;
  z-index: 100;
  height: 60px;
  padding: 0 32px;
  transition: background 0.3s;

  .nav-left-section {
    display: flex;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;

    .logo-area {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      .logo-icon {
        display: flex;
        align-items: center;

        img {
          width: 140px;
          height: 34px;
        }
      }

      .logo-sub {
        font-size: 13px;
        color: var(--text-secondary);
        margin-left: 4px;
        padding-left: 12px;
        border-left: 1px solid var(--border-color);
      }
    }

    .company-area {
      display: flex;
      flex-direction: column;
      gap: 2px;

      /deep/ .el-dropdown {
        display: flex;
        flex-direction: column;
        gap: 2px;
      }

      .company-name-wrapper {
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 6px;
        transition: background 0.2s;

        &:hover,
        &.active {
          background: rgba(0, 0, 0, 0.04);
        }

        .company-name {
          font-size: 15px;
          font-weight: 600;
          color: var(--text-body);
          transition: color 0.2s;

          &:hover {
            color: var(--nav-active);
          }
        }

        .company-arrow {
          font-size: 12px;
          color: var(--text-secondary);
          transition: transform 0.3s;

          &.is-reverse {
            transform: rotate(180deg);
          }
        }
      }

      .role-text {
        font-size: 12px;
        color: var(--text-secondary);
        padding-left: 8px;
      }
    }
  }

  .nav-center {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    gap: 0;

    .nav-item {
      position: relative;
      padding: 0 28px;
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 15px;
      color: var(--text-body);
      cursor: pointer;
      transition: color 0.3s;
      font-weight: 500;
      white-space: nowrap;

      .config-guide-nav-label {
        display: inline-flex;
        align-items: center;
        padding: 7px 12px;
      }

      &:hover {
        color: var(--nav-active);
      }

      &.primary-menu.active {
        color: var(--nav-active);
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          bottom: 14px;
          left: 50%;
          transform: translateX(-50%);
          width: 24px;
          height: 3px;
          background: var(--nav-active);
          border-radius: 2px;
        }
      }

      .nav-badge {
        position: absolute;
        top: 12px;
        right: 14px;
      }
    }
  }

  .nav-right-section {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;

    .customer-service-btn {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 4px;

      .cs-icon-wrapper {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(135deg, var(--primary), var(--primary-hover, #36cfc9));
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
        transition: transform 0.3s;
        position: relative;
        z-index: 1;

        i {
          font-size: 18px;
          color: #fff;
        }
      }

      .cs-badge {
        position: absolute;
        top: -2px;
        right: -6px;
        font-size: 9px;
        color: #fff;
        background: #52c41a;
        padding: 1px 5px;
        border-radius: 8px;
        line-height: 1.3;
        font-weight: 600;
        z-index: 2;
        border: 1.5px solid var(--nav-bg);
      }

      .cs-pulse-ring {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 2px solid var(--primary);
        transform: translate(-50%, -50%);
        animation: cs-pulse 2s ease-out infinite;
        opacity: 0;

        &.delay {
          animation-delay: 1s;
        }
      }

      &:hover .cs-icon-wrapper,
      &.active .cs-icon-wrapper {
        transform: scale(1.1);
        box-shadow: 0 4px 14px rgba(var(--primary-rgb), 0.38);
      }

      &.active .cs-pulse-ring {
        animation-play-state: paused;
        opacity: 0;
      }
    }

    .user-area {
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;
      min-height: 52px;
      padding: 4px 10px;
      border-radius: 8px;
      transition: background 0.2s;

      &:hover,
      &.active {
        background: rgba(0, 0, 0, 0.04);
      }

      .user-avatar-wrap {
        position: relative;
        display: flex;
        width: 48px;
        height: 48px;
        flex-shrink: 0;
        align-items: flex-end;
        justify-content: center;

        .user-avatar {
          background: var(--nav-avatar-bg);
          color: var(--nav-active);
          font-size: 14px;
        }
      }

      .user-name {
        display: block;
        max-width: 120px;
        overflow: hidden;
        color: var(--text-body);
        font-size: 15px;
        font-weight: bold;
        line-height: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .user-name-wrap {
        display: flex;
        min-width: 0;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 1px;
      }

      .user-name-row {
        display: flex;
        min-width: 0;
        align-items: center;
        gap: 8px;

        .user-name { min-width: 0; }
      }

      .user-legal-label {
        flex-shrink: 0;
        padding: 0 6px;
        border-radius: 4px;
        color: var(--primary);
        background: var(--primary-light);
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        white-space: nowrap;
      }

      .super-vip-label {
        position: absolute;
        top: 1px;
        left: 50%;
        z-index: 1;
        display: inline-flex;
        min-width: 34px;
        padding: 0 6px;
        transform: translateX(-50%) skewX(-10deg);
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        background: linear-gradient( 90deg, #FF7611 0%, #FFC14D 100%);
        box-shadow: 0 2px 5px rgba(237, 108, 0, 0.22);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        line-height: 17px;
        text-align: center;
        white-space: nowrap;

        .super-vip-text {
          transform: skewX(12deg);
        }
      }

      .user-role-label {
        display: block;
        max-width: 120px;
        overflow: hidden;
        color: var(--text-secondary);
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .user-arrow {
        margin-left: 8px;
        color: var(--text-secondary);
        font-size: 16px;
        font-weight: 700;
        transition: transform 0.3s;

        &.is-reverse {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.top-nav-children {
  background: var(--nav-bg);
  border-bottom: 1px solid var(--border-light);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  position: sticky;
  top: 60px;
  z-index: 99;
  transition: background 0.3s;

  .nav-center {
    display: flex;
    align-items: center;
    padding: 0 32px;
    height: 48px;
    gap: 0;

    .nav-item.sub-menu {
      padding: 0 24px;
      height: 48px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: var(--text-secondary);
      cursor: pointer;
      transition: color 0.3s;
      font-weight: 400;
      white-space: nowrap;

      .config-guide-service-label {
        display: inline-flex;
        align-items: center;
        padding: 6px 10px;
        line-height: 20px;
      }

      &:hover {
        color: var(--nav-active);
      }

      &.active {
        color: var(--nav-active);
        font-weight: 600;
      }
    }
  }
}

/* ===== 下拉菜单样式（需要穿透 scoped） ===== */
/deep/ .user-dropdown-menu {
  min-width: 200px;
  padding: 4px 0 8px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  background: #ffffff !important;

  .dropdown-user-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #ffffff;

    .header-avatar {
      background: var(--nav-avatar-bg);
      flex-shrink: 0;
    }

    .header-info {
      .header-name {
        font-size: 14px;
        font-weight: 600;
        color: var(--text-title);
        margin-bottom: 2px;
      }

      .header-role {
        font-size: 12px;
        color: var(--text-secondary);
      }
    }
  }

  .dropdown-divider {
    height: 1px;
    background: var(--border-light);
    margin: 4px 0;
  }

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 16px;
    font-size: 14px;
    color: var(--text-body);
    background: #ffffff;

    i {
      font-size: 15px;
      width: 16px;
    }

    .theme-current-tag {
      margin-left: auto;
      font-size: 11px;
      color: #fff;
      background: var(--primary);
      padding: 1px 6px;
      border-radius: 10px;
    }

    &:hover {
      background: #f5f5f5;
      color: var(--primary);
    }

    &.logout-item {
      color: #ff4d4f;

      i {
        color: #ff4d4f;
      }

      &:hover {
        background: #fff1f0;
        color: #ff4d4f;
      }
    }
  }

  .el-dropdown-menu__item--divided {
    border-top: 1px solid #f0f0f0;
    margin-top: 4px;
    padding-top: 9px;
  }
}

/* ===== 公司切换下拉菜单 ===== */
/deep/ .company-dropdown-menu {
  min-width: 220px;
  padding: 6px 0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  background: #ffffff !important;

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    font-size: 14px;
    color: var(--text-body);
    background: #ffffff;
    transition: all 0.2s;
    line-height: 1.4;

    &:not(.is-disabled):hover {
      background: #f5f7fa;
      color: var(--primary);
    }

    &.is-current {
      color: var(--primary);
      font-weight: 600;
      background: var(--primary-light);
    }

    .company-item-name {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .company-check-icon {
      font-size: 14px;
      color: var(--primary);
      flex-shrink: 0;
      margin-left: 8px;
    }
  }
}

/* ===== 换肤抽屉 ===== */
.theme-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;

  &.show {
    opacity: 1;
    pointer-events: all;
  }
}

.theme-drawer {
  position: fixed;
  top: 0;
  right: -440px;
  width: 420px;
  height: 100vh;
  background: #fff;
  z-index: 1001;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  transition: right 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;

  &.show {
    right: 0;
  }

  .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;

    .drawer-title {
      font-size: 16px;
      font-weight: 600;
      color: #1a1a1a;

      i {
        color: var(--primary);
        margin-right: 6px;
      }
    }

    .drawer-close {
      font-size: 18px;
      color: #999;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: #333;
      }
    }
  }

  .drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 24px;

    .drawer-desc {
      font-size: 13px;
      color: #999;
      margin-bottom: 20px;
    }

    .theme-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 14px;
      margin-bottom: 12px;

      .theme-card {
        border: 2px solid #e8e8e8;
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;
        transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;

        &:hover {
          border-color: var(--primary);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }

        &.active {
          border-color: var(--primary);
          box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15);
        }

        .theme-preview {
          height: 88px;
          overflow: hidden;
          background: #f5f5f5;

          .preview-nav {
            height: 18px;
            display: flex;
            align-items: center;
            padding: 0 6px;
            gap: 4px;

            .preview-logo {
              width: 20px;
              height: 8px;
              border-radius: 2px;
            }

            .preview-nav-dots {
              display: flex;
              gap: 4px;
              margin-left: auto;

              span {
                width: 14px;
                height: 5px;
                border-radius: 2px;
              }
            }
          }

          .preview-content {
            height: 54px;
            padding: 6px;
            display: flex;
            gap: 6px;
            align-items: flex-start;

            .preview-card {
              flex: 1;
              background: #fff;
              border-radius: 4px;
              padding: 5px;

              .preview-bar {
                height: 5px;
                border-radius: 2px;
                margin-bottom: 4px;
                width: 60%;
              }

              .preview-line {
                height: 3px;
                background: #e8e8e8;
                border-radius: 2px;
                margin-bottom: 3px;
              }

              .preview-line.short {
                width: 50%;
              }
            }

            .preview-btn {
              width: 20px;
              height: 16px;
              border-radius: 3px;
              flex-shrink: 0;
            }
          }
        }

        .theme-label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 10px 4px;

          .theme-name {
            font-size: 13px;
            font-weight: 600;
            color: var(--text-title);
          }

          .theme-check {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: var(--primary);
            display: flex;
            align-items: center;
            justify-content: center;

            i {
              font-size: 10px;
              color: #fff;
            }
          }
        }

        .theme-palette {
          display: flex;
          gap: 4px;
          padding: 4px 10px 10px;

          .palette-dot {
            width: 14px;
            height: 14px;
            border-radius: 50%;
          }
        }
      }
    }

    .custom-color-section,
    .font-size-section {
      margin-bottom: 0;

      .section-title {
        font-size: 13px;
        font-weight: 600;
        color: var(--text-title);
        margin-bottom: 12px;
      }
    }

    .color-picker-row {
      display: flex;
      align-items: center;
      gap: 12px;

      .color-value {
        font-size: 13px;
        color: var(--text-secondary);
        font-family: monospace;
      }
    }
  }

  .drawer-footer {
    border-top: 1px solid #f0f0f0;
    padding: 16px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    flex-shrink: 0;
  }
}


/* ===== 固定问答在线客服 ===== */
.customer-service-panel {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 3000;
  width: 400px;
  height: 620px;
  max-height: calc(100vh - 88px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(var(--primary-rgb), 0.16);
  border-radius: 16px;
  background: var(--bg-card, #fff);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18), 0 6px 18px rgba(var(--primary-rgb), 0.12);
  transform-origin: bottom right;

  &.is-dragging {
    box-shadow: 0 22px 56px rgba(15, 23, 42, 0.22), 0 8px 22px rgba(var(--primary-rgb), 0.16);
  }
}

.customer-service-header {
  position: relative;
  flex: 0 0 82px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  overflow: hidden;
  color: #fff;
  cursor: grab;
  user-select: none;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%);

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    pointer-events: none;
  }

  &::before {
    width: 106px;
    height: 106px;
    top: -64px;
    right: 46px;
  }

  &::after {
    width: 68px;
    height: 68px;
    right: -24px;
    bottom: -30px;
  }
}

.customer-service-panel.is-dragging .customer-service-header {
  cursor: grabbing;
}

.customer-service-profile,
.customer-service-actions {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.customer-service-profile {
  min-width: 0;
  gap: 12px;
}

.customer-service-avatar {
  position: relative;
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.42);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);

  >i {
    font-size: 23px;
    color: #fff;
  }
}

.customer-service-status-dot {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 12px;
  height: 12px;
  border: 2px solid var(--primary);
  border-radius: 50%;
  background: #52c41a;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9);
}

.customer-service-heading {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;

  strong {
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  span {
    overflow: hidden;
    color: rgba(255, 255, 255, 0.82);
    font-size: 12px;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.customer-service-actions {
  gap: 6px;
  margin-left: 10px;
}

.customer-service-action {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.88);
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  outline: none;
  transition: color 0.2s, background 0.2s, transform 0.2s;

  i {
    font-size: 16px;
  }

  &:hover,
  &:focus-visible {
    color: var(--primary);
    background: #fff;
    transform: translateY(-1px);
  }
}

.customer-service-messages {
  flex: 1 1 auto;
  min-height: 120px;
  padding: 14px 16px 18px;
  overflow-x: hidden;
  overflow-y: auto;
  background:
    radial-gradient(circle at 100% 0, rgba(var(--primary-rgb), 0.07), transparent 34%),
    var(--bg-page, #f5f6f8);
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: rgba(var(--primary-rgb), 0.22);
  }
}

.customer-service-time {
  width: max-content;
  margin: 0 auto 14px;
  padding: 3px 9px;
  border-radius: 10px;
  color: var(--text-secondary, #64748b);
  background: rgba(15, 23, 42, 0.05);
  font-size: 11px;
  line-height: 16px;
}

.customer-service-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;

  &.user {
    flex-direction: row-reverse;

    .customer-service-message-avatar {
      color: #fff;
      background: var(--primary);
    }

    .customer-service-bubble {
      color: #fff;
      border-color: transparent;
      border-radius: 12px 4px 12px 12px;
      background: linear-gradient(135deg, var(--primary), var(--primary-hover));
      box-shadow: 0 4px 12px rgba(var(--primary-rgb), 0.18);
    }
  }

  &.service .customer-service-bubble {
    border-radius: 4px 12px 12px 12px;
  }
}

.customer-service-message-avatar {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(var(--primary-rgb), 0.14);
  border-radius: 9px;
  color: var(--primary);
  background: var(--primary-light, #fff3e8);

  i {
    font-size: 15px;
  }
}

.customer-service-bubble {
  max-width: 286px;
  padding: 9px 12px;
  border: 1px solid var(--border-light, #f0f0f0);
  color: var(--text-body, #333);
  background: var(--bg-card, #fff);
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
  font-size: 13px;
  line-height: 21px;
  word-break: break-word;
}

.customer-service-typing {
  min-width: 58px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--primary);
    animation: customer-service-typing 1.2s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.15s;
    }

    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }
}

.customer-service-faq {
  flex: 0 0 266px;
  display: flex;
  flex-direction: column;
  padding: 15px 16px 11px;
  border-top: 1px solid var(--border-light, #f0f0f0);
  background: var(--bg-card, #fff);
}

.customer-service-faq-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 11px;

  >div {
    display: flex;
    align-items: center;
    gap: 7px;
  }

  i {
    color: var(--primary);
    font-size: 17px;
  }

  strong {
    color: var(--text-title, #0f172a);
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }

  >span {
    color: var(--text-secondary, #64748b);
    font-size: 11px;
  }
}

.customer-service-question-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.customer-service-question {
  min-width: 0;
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 9px;
  border: 1px solid var(--border-color, #e8e8e8);
  border-radius: 9px;
  color: var(--text-body, #333);
  background: var(--bg-card, #fff);
  cursor: pointer;
  outline: none;
  transition: color 0.2s, border-color 0.2s, background 0.2s, transform 0.2s, box-shadow 0.2s;

  &:hover:not(:disabled),
  &:focus-visible {
    color: var(--primary);
    border-color: rgba(var(--primary-rgb), 0.45);
    background: var(--primary-light, #fff3e8);
    box-shadow: 0 4px 12px rgba(var(--primary-rgb), 0.09);
    transform: translateY(-1px);

    .customer-service-question-index {
      color: #fff;
      background: var(--primary);
    }

    >i {
      opacity: 1;
      transform: translateX(2px);
    }
  }

  &:disabled {
    cursor: wait;
    opacity: 0.58;
  }

  >i {
    flex: 0 0 auto;
    margin-left: 3px;
    color: var(--primary);
    font-size: 12px;
    opacity: 0.55;
    transition: opacity 0.2s, transform 0.2s;
  }
}

.customer-service-question-index {
  width: 21px;
  height: 21px;
  flex: 0 0 21px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 7px;
  border-radius: 7px;
  color: var(--primary);
  background: var(--primary-light, #fff3e8);
  font-size: 11px;
  font-weight: 600;
  transition: color 0.2s, background 0.2s;
}

.customer-service-question-text {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  font-size: 12px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.customer-service-footer-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: auto;
  padding-top: 9px;
  color: var(--text-secondary, #64748b);
  font-size: 11px;

  i {
    color: var(--success, #10b981);
    font-size: 13px;
  }
}

.customer-service-pop-enter-active,
.customer-service-pop-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.customer-service-pop-enter,
.customer-service-pop-leave-to {
  opacity: 0;
  transform: translateY(10px) scale(0.96);
}

@keyframes customer-service-typing {

  0%,
  60%,
  100% {
    opacity: 0.35;
    transform: translateY(0);
  }

  30% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

@media (max-width: 640px) {
  .customer-service-panel {
    right: 10px;
    bottom: 12px;
    left: 10px;
    width: auto;
    height: calc(100vh - 78px);
    max-height: 650px;
    border-radius: 14px;
  }

  .customer-service-faq {
    flex-basis: 258px;
    padding-right: 12px;
    padding-left: 12px;
  }

  .customer-service-question {
    padding: 0 7px;
  }

  .customer-service-question-index {
    margin-right: 5px;
  }
}

@keyframes cs-pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }

  100% {
    transform: translate(-50%, -50%) scale(1.8);
    opacity: 0;
  }
}
</style>

<style lang="less">
.config-first-visit-popover.driver-popover {
  --guide-hero-cutout: 62px;
  --guide-corner-radius: 26px;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 500px;
  height: 224px;
  min-width: 0;
  min-height: 224px;
  max-width: calc(100vw - 24px);
  padding: 24px 30px 20px;
  border-radius: var(--guide-corner-radius);
  background-color: transparent;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  font-family: inherit;
  text-align: left;

  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
  }

  .config-first-visit-background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: block;
    width: 100%;
    height: auto;
    pointer-events: none;
  }

  &::after {
    inset: var(--guide-hero-cutout) 0 0;
    z-index: 1;
    border-radius: 0 var(--guide-corner-radius) var(--guide-corner-radius) var(--guide-corner-radius);
    background: #fff;
  }

  .config-first-visit-illustration {
    position: absolute;
    z-index: 0;
    top: -100px;
    right: 2px;
    width: 156px;
    height: 166px;
    overflow: hidden;
    pointer-events: none;

    img { display: block; width: 156px; height: 255px; }
  }

  .driver-popover-arrow,
  .driver-popover-footer,
  .driver-popover-close-btn {
    display: none;
  }

  .driver-popover-title {
    position: relative;
    z-index: 3;
    flex-shrink: 0;
    max-width: calc(100% - 150px);
    margin: 0;
    color: #111;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
  }

  .driver-popover-description {
    position: relative;
    z-index: 3;
    min-height: 0;
    margin: 16px 0 0;
    padding: 0;
    overflow-y: auto;
    color: #666;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .driver-popover-title + .driver-popover-description { margin-top: 21px; }

  .config-first-visit-actions {
    position: relative;
    z-index: 3;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: auto;
    padding-top: 17px;

    button {
      min-width: 140px;
      min-height: 44px;
      padding: 8px 16px;
      border: 1px solid #ff8000;
      border-radius: 8px;
      background: #fff;
      color: #ff8000;
      font: inherit;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
    }

    button:focus-visible {
      outline: 2px solid #ff8000;
      outline-offset: 2px;
    }

    .config-first-visit-skip {
      min-width: 140px;

      &:hover { background: #fff5eb; }
    }

    .config-first-visit-next {
      background: #ff8000;
      color: #fff;

      &:hover { background: #ed6c00; border-color: #ed6c00; }
    }
  }

  &:not(.config-guide-step-0) .config-first-visit-skip {
    min-width: 0;
    margin-right: auto;
    padding: 0;
    border: 0;
    background: transparent;
    color: #999;
    font-weight: 400;

    &:hover { background: transparent; color: #666; }
  }

  &.config-guide-step-0 .config-first-visit-skip:focus-visible {
    outline: none;
    border-width: 2px;
  }
}

.config-first-visit-popover.driver-popover:not(.config-guide-step-0) {
  height: auto;
  min-height: 0;
  padding-bottom: 20px;

  .config-first-visit-actions {
    margin-top: 20px;
    padding-top: 0;
  }
}

.config-first-visit-popover.driver-popover.config-guide-step-1 {
  margin-top: 30px;
}

@media (max-width: 640px) {
  .config-first-visit-popover.driver-popover {
    --guide-hero-cutout: 34px;
    --guide-corner-radius: 18px;
    padding: 25px 20px 22px;

    .config-first-visit-illustration {
      top: -62px;
      right: 2px;
      width: 102px;
      height: 105px;

      img { width: 102px; height: auto; }
    }

    &.config-guide-step-1 { margin-top: 0; }

    .driver-popover-title { max-width: calc(100% - 100px); }

    .config-first-visit-actions {
      gap: 8px;

      button,
      .config-first-visit-skip { min-width: 74px; min-height: 36px; padding: 6px 10px; font-size: 13px; }
    }
  }
}
</style>

<style lang="less">
.user-dropdown-menu .super-vip-dropdown-card {
  box-sizing: border-box;
  width: calc(100% - 24px);
  margin: 8px 12px;
  padding: 10px 12px;
  border: 1px solid #efd5c5;
  border-radius: 8px;
  background: #F7E6DB;
  color: #855035;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover,
  &:focus-visible {
    border-color: #e8bda2;
    box-shadow: 0 7px 18px rgba(132, 72, 35, 0.12);
    outline: none;
    transform: translateY(-1px);
  }

  .super-vip-card-title {
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
  }

  .super-vip-card-expire {
    margin-top: 3px;
    color: #a16d4e;
    font-size: 11px;
    line-height: 16px;
  }
}

.super-vip-benefits-dialog {
  width: calc(100% - 24px) !important;
  max-width: 460px;
  margin-bottom: 24px;
  overflow: hidden;
  border-radius: 16px;
  background: #f7f7f7;
  box-shadow: 0 18px 55px rgba(54, 34, 21, 0.24);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-loading-mask {
    border-radius: 16px;
  }
}

.super-vip-benefits {
  color: #343434;
  background: #f7f7f7;
  font-variant-numeric: tabular-nums;
}

.super-vip-hero {
  position: relative;
  min-height: 180px;
  padding: 34px 26px 26px;
  overflow: hidden;
  color: #fff;
  background: linear-gradient(135deg, #ff9600 0%, #ff6b00 100%);
  box-sizing: border-box;

  &::before,
  &::after {
    position: absolute;
    border-radius: 50%;
    content: '';
    pointer-events: none;
  }

  &::before {
    top: -116px;
    right: -28px;
    width: 250px;
    height: 250px;
    background: rgba(255, 184, 77, 0.22);
  }

  &::after {
    bottom: -108px;
    left: 92px;
    width: 220px;
    height: 220px;
    background: rgba(255, 149, 0, 0.26);
  }
}

.super-vip-dialog-close {
  position: absolute;
  top: 13px;
  right: 14px;
  z-index: 2;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  color: #55321a;
  background: transparent;
  font-size: 24px;
  line-height: 34px;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: #2f1a0d;
    background: rgba(255, 255, 255, 0.2);
    outline: 2px solid rgba(255, 255, 255, 0.8);
    outline-offset: 1px;
  }
}

.super-vip-status {
  position: relative;
  z-index: 1;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 4px 11px;
  border-radius: 14px;
  color: #fff7e9;
  background: rgba(255, 255, 255, 0.18);
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;

  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #cfff59;
    box-shadow: 0 2px 5px rgba(118, 148, 33, 0.28);
  }
}

.super-vip-hero-main {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.super-vip-hero-copy {
  min-width: 0;

  h3 {
    margin: 0;
    color: #fff;
    font-size: 27px;
    font-weight: 700;
    line-height: 38px;
    letter-spacing: -0.02em;
    white-space: nowrap;

    strong {
      margin-left: 6px;
      color: #fff;
      font-weight: 700;
      text-decoration: underline;
      text-decoration-thickness: 2px;
      text-underline-offset: 7px;
    }
  }

  p {
    margin: 12px 0 0;
    color: #fff4e7;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
}

.super-vip-mark {
  width: 76px;
  height: 86px;
  flex: 0 0 auto;
  margin-right: 10px;
  fill: none;
  stroke: rgba(255, 255, 255, 0.9);
  stroke-linejoin: round;
  stroke-width: 5;

  path:nth-child(2) {
    stroke-width: 4;
  }

  path:nth-child(3) {
    stroke-width: 4;
  }
}

.super-vip-rights {
  margin-top: 10px;
  background: #fff;
}

.super-vip-rights-header {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 22px;
  border-bottom: 1px solid #ededed;
  box-sizing: border-box;

  h4 {
    margin: 0;
    color: #2f2f2f;
    font-size: 17px;
    font-weight: 700;
    line-height: 24px;
  }
}

.super-vip-invoice-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 5px;
  border: 0;
  border-radius: 6px;
  color: #407cff;
  background: transparent;
  font-size: 12px;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: #245cd6;
    background: #edf3ff;
    outline: 2px solid rgba(64, 124, 255, 0.26);
    outline-offset: 1px;
  }
}

.super-vip-comparison-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    height: 59px;
    padding: 0 10px;
    border-bottom: 1px solid #eeeeee;
    color: #8b8b8b;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    box-sizing: border-box;
  }

  th:first-child {
    width: 42%;
    padding-left: 22px;
    color: #555;
    text-align: left;
  }

  thead th {
    height: 52px;
    color: #989898;
  }

  thead th:first-child {
    color: #686868;
  }

  th:last-child,
  td:last-child {
    color: #ff7a1a;
    font-weight: 600;
  }

  tbody tr:last-child th,
  tbody tr:last-child td {
    border-bottom: 0;
  }
}

.super-vip-priority {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 13px;
  color: #ff8a25;
  background: #fff4e6;
  font-size: 13px;
  line-height: 18px;
}

.super-vip-note {
  margin: 0;
  padding: 16px 20px 18px;
  color: #aaa;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

@media (max-width: 480px) {
  .super-vip-hero {
    min-height: 168px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .super-vip-hero-copy h3 {
    font-size: 22px;
  }

  .super-vip-mark {
    width: 58px;
    height: 68px;
    margin-right: 2px;
  }

  .super-vip-comparison-table {

    th,
    td {
      padding-right: 6px;
      padding-left: 6px;
      font-size: 12px;
    }

    th:first-child {
      padding-left: 16px;
    }
  }
}

.unverified-guide-dialog {
  border-radius: 8px !important;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    position: relative;
    padding: 0;
  }
}

.unverified-skip {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
  min-width: 46px;
  height: 24px;
  padding: 0 12px;
  border: 0;
  border-radius: 12px;
  color: #c7c9cf;
  background: #F4F4F4;
  font-size: 12px;
  cursor: pointer;
}

.unverified-guide {
  min-height: 304px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 44px 30px 36px 52px;
  background: linear-gradient(90deg, #ffffff 0%, #fff8f3 100%);
  box-sizing: border-box;
}

.unverified-content {
  width: 340px;

  h3 {
    margin: 0 0 14px;
    color: #222b45;
    font-size: 24px;
    line-height: 34px;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: #9aa1ad;
    font-size: 13px;
    line-height: 22px;
  }
}

.unverified-action {
  width: 166px;
  height: 34px;
  margin-top: 52px;
  border: 0;
  border-radius: 4px;
  background: #ff7a00 !important;
  font-size: 14px;

  &:hover,
  &:focus {
    background: #ff8a1f !important;
  }
}

.unverified-tip {
  margin-top: 12px;
  color: #c6c9d1;
  font-size: 12px;
  line-height: 18px;
}

.unverified-icon {
  width: 190px;
  height: 190px;
  object-fit: contain;
  flex-shrink: 0;
}

/* ===== 企业认证弹框 ===== */
.cert-dialog {
  border-radius: 12px !important;
  overflow: hidden;

  .el-dialog__header {
    padding: 18px 24px 14px;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 14px 24px;
    border-top: 1px solid #f0f0f0;
    text-align: center;
  }

  .cert-dialog-title {
    .cert-title-text {
      font-size: 18px;
      font-weight: 700;
      color: #1a1a1a;
    }
  }

  .cert-dialog-body {
    display: flex;
    min-height: 520px;
    padding: 25px;
  }

  /* 左侧橙色插画区域 */
  .cert-left {
    width: 480px;
    flex-shrink: 0;
    background: linear-gradient(160deg, #ffa940, #ff7a00);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    overflow: hidden;

    .cert-illustration {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .cert-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }

  /* 右侧表单区域 */
  .cert-right {
    flex: 1;
    padding: 28px 40px 20px;
    overflow-y: auto;

    .cert-success-status {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      padding: 10px 12px;
      color: #1f9d55;
      background: #f0f9eb;
      border: 1px solid #d8f0cd;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;

      i {
        font-size: 18px;
      }
    }

    .cert-status-row {
      display: flex;
      gap: 12px;
      margin-bottom: 16px;

      .cert-success-status {
        flex: 1;
        min-width: 0;
        margin-bottom: 0;
      }
    }

    .legal-cert-status {
      &.is-uncertified {
        color: #e6a23c;
        background: #fdf6ec;
        border-color: #faecd8;
      }
    }

    .cert-section-title {
      position: relative;
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 18px;
      padding-left: 10px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 2px;
        width: 3px;
        height: 14px;
        border-radius: 2px;
        background: #1989fa;
      }
    }

    .cert-tip {
      color: #f56c6c;
      font-size: 13px;
      margin-bottom: 18px;
      line-height: 1.8;
    }

    .cert-register-form {
      width: 100%;
      max-width: 572px;
      margin: 0 auto;
    }

    .el-form-item {
      margin-bottom: 12px;
    }

    .el-form-item__label {
      color: #666;
      font-size: 14px;
    }

    .cert-readonly-text {
      font-size: 14px;
      color: #333;
      line-height: 32px;
      word-break: break-all;
    }

    .cert-license-view {
      width: 148px;
      height: 108px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      cursor: pointer;
    }

    .cert-detail-address .el-textarea__inner {
      font-size: 13px;
      font-weight: 400;
      color: #606266;
      font-family: inherit;

      &::placeholder {
        font-size: 13px;
        font-weight: 400;
        color: #c0c4cc;
        font-family: inherit;
      }

      &::-webkit-input-placeholder {
        font-size: 13px;
        font-weight: 400;
        color: #c0c4cc;
        font-family: inherit;
      }

      &::-moz-placeholder {
        font-size: 13px;
        font-weight: 400;
        color: #c0c4cc;
        font-family: inherit;
      }

      &:-ms-input-placeholder {
        font-size: 13px;
        font-weight: 400;
        color: #c0c4cc;
        font-family: inherit;
      }
    }

    .cert-field-tip {
      font-size: 12px;
      color: #bbb;
      margin-left: 8px;
      white-space: nowrap;
    }

    .cert-sync-row {
      margin: 15px 0 8px 106px;

      .el-form-item__content {
        line-height: 22px;
      }

      .el-checkbox {
        color: #606266;
        font-size: 13px;
        line-height: 22px;
        white-space: normal;
      }

      .el-checkbox__label {
        color: #606266;
        font-size: 13px;
        line-height: 22px;
        vertical-align: top;
      }
    }

    .cert-auth-method {
      display: flex;
      align-items: center;
      min-height: 32px;
      gap: 26px;

      .el-radio {
        margin-right: 0;
      }
    }

    .cert-link {
      color: var(--primary);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    /* 上传区域：左图右文字并排 */
    .cert-upload-row {
      display: flex;
      gap: 20px;
      align-items: flex-start;

      .cert-upload-area {
        flex-shrink: 0;

        .cert-upload {
          position: relative;
          width: 148px;
          height: 108px;

          .el-upload--picture-card {
            width: 148px;
            height: 108px;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            visibility: visible;
            transition: visibility 0s;
          }

          .upload-trigger {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }

          /* 文件列表绝对定位覆盖在上传按钮上方，避免布局跳动 */
          .el-upload-list--picture-card {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;

            .el-upload-list__item {
              width: 148px;
              height: 108px;
              margin: 0;
            }

            .el-upload-list__item-actions {
              display: flex;
              align-items: center;
              justify-content: center;

              .el-upload-list__item-delete {
                order: 1;
                margin-left: 0;
              }

              .el-upload-list__item-preview {
                order: 2;
                margin-left: 15px;
              }
            }
          }

          .el-icon-plus {
            font-size: 24px;
            color: #bbb;
          }

          /* 上传后用visibility隐藏按钮（保留占位），删除后自动恢复 */
          &.has-file .el-upload--picture-card {
            visibility: hidden;
          }
        }
      }

      .cert-upload-tips {
        flex: 1;
        padding-top: 4px;

        p {
          font-size: 12px;
          color: #999;
          line-height: 2;
          margin: 0;
        }
      }
    }

    .cert-next-row {
      margin-top: 28px;
      text-align: center;

      .el-button {
        width: 100px;
        height: 32px;
        padding: 0;
        border-radius: 2px;
        background: #ff7800;
        border-color: #ff7800;
        font-size: 12px;

        &:hover,
        &:focus {
          background: #ff8c1a;
          border-color: #ff8c1a;
        }
      }

      .cert-cancel-button {
        color: #606266;
        background: #fff;
        border-color: #dcdfe6;

        &:hover,
        &:focus {
          color: #ff7800;
          background: #fff7f0;
          border-color: #ffb36e;
        }
      }
    }
  }

  /* 底部按钮 */
  .cert-dialog-footer {
    .el-button {
      min-width: 100px;
      padding: 8px 28px;
      border-radius: 4px;
    }

    .el-button--warning {
      background: #ff8c00;
      border-color: #ff8c00;

      &:hover {
        background: #ffa940;
        border-color: #ffa940;
      }
    }
  }
}

/* ===== 修改密码弹框 ===== */
.pwd-dialog {
  border-radius: 10px !important;

  .el-dialog__header {
    padding: 18px 24px 14px;
    border-bottom: 1px solid #f0f0f0;
  }

  .pwd-dialog-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 17px;
    font-weight: 600;
    color: #1a1a1a;

    i {
      font-size: 18px;
      color: var(--primary);
    }
  }

  .el-dialog__body {
    padding: 28px 32px 12px;
  }

  .el-input {
    width: 280px;
  }

  .pwd-form-tip {
    font-size: 12px;
    line-height: 18px;
    width: 100%;
  }

  .pwd-dialog-footer {
    .el-button {
      min-width: 80px;
      padding: 8px 24px;
    }

    .el-button--primary {
      background: var(--primary);
      border-color: var(--primary);

      &:hover {
        background: var(--primary-hover);
        border-color: var(--primary-hover);
      }
    }
  }
}
</style>
